import React from 'react';
import Router from 'next/router';
import { get, post } from '$ACTIONS/TlcRequest';
import { ApiPort } from '$ACTIONS/TLCAPI';
import { depositMoneyInt, depositMoneyDecimal } from '$ACTIONS/reg';
import HostConfig from '$ACTIONS/Host.config';
import CMSOBJ from '$DATA/stage.live.static.id';
import { getDepositVerifyInfo } from '$ACTIONS/helper';
import { getAttemptVal } from "$ACTIONS/OTPUtil";
import BlanceModal from './blanceModal';
import FinishStep from '../Wallet/withdrawComponents/FinishStep/';
import AddBankCard from "../BankAccount/AddBankCard";
import { GetWithdrawalVerification, CheckDigitalCoinWallet } from '$DATA/wallet';
import DigitalcoinUtil from '$ACTIONS/DigitalcoinUtil';

import {
	Modal,
	Button,
	Input,
	Select,
	Form,
	Icon,
	Spin,
	Radio,
	message,
	Popover,
	Steps,
	Divider,
	Checkbox
} from 'antd';
import { getMemberInfo } from '$DATA/userinfo';
import { Cookie, dateFormat, formatSeconds, formatAmount } from '$ACTIONS/util';
import {
	GetMemberBanks,
	GetWithdrawalMethods,
	CommonPostPay,
	GetWithdrawalExchangeRate,
	GETWithdrawalDetails, // deprecated
	GetWithdrawalMethodsDetail, // new
	CheckExchangeRateWallet,
	AddExchangeRateWallets,
	setTDBDefaultWallet,
	getWithdrawalSetUp,
	GetAllBalance,
	TransferSubmit
} from '$DATA/wallet';
import { formItemLayout, tailFormItemLayout } from '$ACTIONS/constantsData';
import DigitalCoinTrait from "$ACTIONS/trait/DigitalCoinTrait";
import WithdrawLesson from '../WithdrawLesson';
import DigitalCoinWithdrawLesson from '../WithdrawLesson/DigitalCoinWithdrawLesson';
import PhoneVerify from '@/Verification/PhoneVerify';
import ExceedVerify from '@/OTP/ExceedVerify';
import AddWalletAddress from '@/BankAccount/AddWalletAddress';
import BankWithdrawalDetails from '@/BankAccount/BankWithdrawalDetails';
import BankAccountModals from '@/BankAccount/BankAccountModals';
import LBBankAccount from './withdrawComponents/LBBankAccount';
import CardId from '@/RealyName/CardId';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { BsCheckSquareFill } from 'react-icons/bs';
import AccountVerification from './withdrawComponents/AccountVerification';
import { Span } from '@sentry/nextjs';

const { Option } = Select;
const { Item } = Form;
const { Step } = Steps;

const CCWReminderLogic = that => {
    const initIsWithdrawalCCWDidMountAndAPIDataCompletedPart = () => {
        that.isWithdrawalCCWDidMountAndAPIDataCompletedPart1 = false;
        that.isWithdrawalCCWDidMountAndAPIDataCompletedPart2 = false;
    };
    const isNeedToOpenReminderModal = () => {
        return that.props.currentWithdrawKey === 'CCW' && !localStorage.getItem('isFirstUSDTWithdraw')
    }

    return {
        init: () => {
            initIsWithdrawalCCWDidMountAndAPIDataCompletedPart();
            that.waitingOpenCCWReminderModalTimer = undefined;
        },
        initIsWithdrawalCCWDidMountAndAPIDataCompletedPart,
        isNeedToOpenReminderModal,
        needToOpenReminderModal: openFunc => {
            that.waitingOpenCCWReminderModalTimer && clearInterval(that.waitingOpenCCWReminderModalTimer);
            that.waitingOpenCCWReminderModalTimer = setInterval(()=>{
                if (!that.isWithdrawalCCWDidMountAndAPIDataCompletedPart1 || !that.isWithdrawalCCWDidMountAndAPIDataCompletedPart2) { return; }
                isNeedToOpenReminderModal() && openFunc && openFunc();
                clearInterval(that.waitingOpenCCWReminderModalTimer);
            },500);
        },
    };
};

class Withdrawal extends React.Component {
	constructor(props) {
		super(props);
		this.cannotUseText1Map = {'LB': '便捷', 'CCW': '虚拟货币', 'DCW': '代币钱包'};
		this.DigitalCoinTrait = DigitalCoinTrait(this);
		this.DEFAULT_ERROR_BOOLEAN = this.DigitalCoinTrait.DEFAULT_ERROR_BOOLEAN;
		this.state = {
			whenAddBankAccountModalVisibleTrueAt: 0,
			isAddBankAccountModalVisible: false,
			isCannotUseVisible: false,
			aryDigitalCoin: [],
			showAll: false, //是否展開所有钱包
			otherWalletTotal: 0,
			defaultBankCardId: -1, // 默认银行卡
			alreadyBindBanks: '', // 已绑定银行卡列表
			isBankUpgradingError: false,
			withdrawMethodsList: [], // 提款方式
			defaultWithdrawMethod: '', // 默认提款方式
			phone: '', // AstroPay 提款方式所需手机号
			isSuccess: false, // 是否成功提交申请
			remainingTime: '00:00', // 倒计时提醒
			visibleExchangeRateWallet: false, //添加泰达币钱包
			tDBName: '', // including digitalCoinType meaning
			tDBAddress: '', // including digitalAddress meaning
			tDBNameError: true, // including digitalCoinTypeError meaning
			tDBAddressError: false,
			tDBAddressError2: this.DEFAULT_ERROR_BOOLEAN,
			minMoney: '', //泰达币最小金额
			maxMoney: '', //泰达币最大金额
			dayMoney: '', //泰达币单日金额
			cryptoMemberType: '', //泰达币會員類型 // including digitalMemberType meaning
			isAbleWithdraw: false,
			CurrentQuota: 0, // 泰达币剩余可提款额度
			IsStaticQuota: false,
			withdrawalMoney: '', //提款金额
			tDBisSuccess: false, // 是否成功提交申请 // including digitalcoinisSuccess meaning
			tDBisSuccessId: '',
			addTDBBtnStatue: false, //泰达币添加钱包按钮状态
			tDBSubmitbtnStatus: false, //泰达币提现提交按钮状态 // including digitalSubmitbtnStatus meaning
			lbWithdrawalDisabledStatus: true, // 银行转账提现按钮禁用状态
			payoutDurationsDisabledStatus: true, //預約時間判斷提交按鈕
			tDBWalletList: [], //泰达币钱包
			defaulttDBWalletId: -1, //默认钱包
			selectTDBName: '',
			selectTDBAddress: '',
			lessonModal: false,
			digitalCoinLessonModal: false,
			checkAbleSmsOTP: {
				isAbleSmsOTP: false, // OTP驗證
				attempts: 0 // 剩餘次數
			},
			isLoading: false,
			phoneVisible: false, // 手機驗證
			memberInfo: '',
			exceedVisible: false, // otp 彈窗
			isShowLBWithdrawalTip: '', //lb提款是否以达到门槛tip
			isLBDescriptionCode: '', //lb提款是否以达到门槛提示code
			isShowLBWithdrawalModal: false, //lb提款是是否以达到门槛modal
			lBWithdrawalFlag: false,
			bankWithdrawalDetail: false, //打开银行卡咨询modal
			bankAccountModal: false, //银行账户限额设置modal
			showUSDTPromotion: true,
			ctcWithdrawType: [], // USDT提款增加ERC、TRC
			digitalcoinWithdrawType: [], // digital-coin 6*methods

			currencyType: '',
			ctcMethod: '', // 当前USDT提款类型
			digitalcoinMethod: '', // current digital-coin method (this value is coinType)
			ExchangeRate1: 0, // 级别1的汇率
			ExchangeRate2: 0, // 级别2的汇率
			ExchangeAmount1: 0, // 级别1的金额
			ExchangeAmount2: 0, // 级别2的金额
			TiersAmount1: 0,
			TiersAmount2: 0,
			ConvertedAmount: 0,
			WithdrawableBalances: 0, // 可免费提现额度
			BalancesUpdatedAt: '', // 更新日期
			DepositedAmount: 0, // 充值总金额
			WithdrawAmount: 0, // 提现总额
			showLBWithdrawalInfo: false, // 是否显示提款额度提醒 21/10/14
			showLBWithdrawalMaxInfo: false,
			suggestedAmounts: [], //LB 快速提款金额
			lbMethodsResult: {}, //lb 提现结果
			payoutMode: '', //提現方法
			rebateAmount: '', //反水紅利
			// isShowBankCardVerif might be dead variable for F
			isShowBankCardVerif: false,
			step: '0',
			submitOTPAttempts: '5',
			userInfo: {
				userName: '',
				currency: 'CNY',
				memberCode: '',
				isDeposited: 0, // 0 未存款，可更新  1 以存款，禁更新
				realyName: '',
				cardId: '',
				phoneNumber: '',
				isBankCardValidated: false,
				phoneStatus: false
			},
			banksVerificationManual: false,
			announcement: false,
			newsList: {},
			AllpayoutDurations: [],
			maxPayoutDurationInMins: '',
			payoutDurationRebatePercent: '',
			transactionId: '',
			defaultAccount: false,
			withdrawalTime: ''
		};

		this.CCWReminderLogic = CCWReminderLogic(this);
		this.CCWReminderLogic.init();
		//
		this.setLoading = this.setLoading.bind(this);
		this.openDeposit = this.openDeposit.bind(this); // 打开未充值提示
		this.openPoint = this.openPoint.bind(this); // 打开提款限制提示
		this.openFinishBankCard = this.openFinishBankCard.bind(this); // 打开未绑定银行卡提示
		this.getDepositFrontData = this.getDepositFrontData.bind(this); // 获取前置数据（会员信息详情）
		this.getWithdrawBanks = this.getWithdrawBanks.bind(this); // 获取用户已绑定的银行卡
		this.goWithdrawHome = this.goWithdrawHome.bind(this); // 跳转到提款首页
		this.startCountDown = this.startCountDown.bind(this); // 开始倒计时
		this.changeBankCard = this.changeBankCard.bind(this); // 已绑定银行卡Value更改
		this.goBankAccount = this.goBankAccount.bind(this); // 前往银行卡管理
		this.getEquivalentCoinAmount = this.getEquivalentCoinAmount.bind(this); //获取泰达币的汇率
		this.GETWithdrawalAnyoneDetails = this.GETWithdrawalAnyoneDetails.bind(this); //获取提现方法的详情
		this.CheckExchangeRateWalletMethod = this.CheckExchangeRateWalletMethod.bind(this); //查询会员虚拟货币錢包
		this.addExchangeRateWallets = this.addExchangeRateWallets.bind(this); //添加泰达币钱包
		this.handleOk = this.handleOk.bind(this);
		this.goRecords = this.goRecords.bind(this);
		this.changeTDBAddress = this.changeTDBAddress.bind(this); //切换钱包地址
		this.changeBtnStatus = this.changeBtnStatus.bind(this);
		this.showdefaulttDBWallet = this.showdefaulttDBWallet.bind(this);
		this.goTransferPage = this.goTransferPage.bind(this);
		this.changeModalBtnStatus = this.changeModalBtnStatus.bind(this);
		this.showInfoModal = this.showInfoModal.bind(this);
		this.setDetaultWallet = this.setDetaultWallet.bind(this); //设置默认钱包
		this.judgeOTPVerification = this.judgeOTPVerification.bind(this); // 查询会员是否能够请求短信OTP
		this.openNoticeOTP = this.openNoticeOTP.bind(this); // OTP注意彈窗
		this.setAttemptRemaining = this.setAttemptRemaining.bind(this); // cry otp 剩餘次數
		this.VerifyStatus = this.VerifyStatus.bind(this); // 驗證彈窗狀態
		this.getVerificationCode = this.getVerificationCode.bind(this); // 獲取otp驗證碼
		this.getLBWithdrawalSetUp = this.getLBWithdrawalSetUp.bind(this); // 获取用户的提款限定
		this.changeErcTrc = this.changeErcTrc.bind(this); // 更改USDT提款币种 // including change digital-coin value
		this.lBWithdrawalBtn = this.lBWithdrawalBtn.bind(this);
		this.getCryptoMemberType = this.getCryptoMemberType.bind(this); // 判斷泰达币會員類型
		this.defaultGdProvince = ["廣東", "广东", "廣东", "广東", "guangdong"];
		this.gdProvince = [];
		this.defaultIcbcBankname = [
			"工商",
			"gongshang",
			"icbc",
			"工商银行",
			"Industrial and Commercial Bank(ICBC)",
			"ICBC",
			"中国工商银行",
			"中国工商",
			"中国工商信号",
			"中國工商銀行",
			"INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PCL",
			"工商银行啊",
			"Industrial and Commercial Bank(ICBC)",
			"INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PCL",
			"中國工商",
			"中國工商銀行信號",
			"中國工商信號"
		];
		this.icbcBankname = [];
		this.withdrawalLimit = {}; // 提款金额限制
		//this.isFinishFrontData = []; // 是否已获取完成当前Page所需前置数据
		this.localMemberName = ''; // 提款前置条件是否完善
		this.withdrawalPromptId = 0; // 临时记录提款前置条件
		this.isAllowWithdraw = false; // 默认不允许提款
		this.isDeposited = false; // 默认未进行充值
		(this.isChooseNotHint = false), // USDT提款汇率提示不再显示单选项值
			(this.timeTimer = null);
		this.usdtWithdrawInputTimer = null;

		this.withdrawalBankCardCountPass = true; // 提款前置数据获取限制（如果获取前置信息的时候提款卡准备就绪，则不做处理，否则当获取到提款卡的时候再次执行获取前置数据逻辑）
		this.mainCurrency = 'RMB';
		this.DigitalCoinTrait.init();
	}
	setLoading(v, o={}) {
		this.props.setLoading(v);
		this.props.setWithdrawalListLoading(v);
		if (o && o.isAnyoneDetailLoaded) { this.props.setOneWithdrawalDetailLoaded() }
		if (o && o.isList1stLoaded) { this.props.setWithdrawalList1stLoaded() }
	}
	getGD_ICBC = () => {
		fetch('https://hsy88fun.moe/CMSFiles/GDICBC/GD_ICBC.json?v=' + Math.random(), { method: 'GET' })
			.then((response) => response.json())
			.then((res) => {
				if (res?.gdProvince) {
					this.gdProvince = res?.gdProvince || []
				}
				if (res?.icbcBankname) {
					this.icbcBankname = res?.icbcBankname || []
				}
			}).catch((error) => { })
	}
	componentDidMount4Reuse(doYouWantToReloadAnyoneDetailMethodWhenDidUpdateWillNotTrigger) {
		if (localStorage.getItem('memberInfo') != undefined) {
			this.setState({
				memberInfo: JSON.parse(localStorage.getItem('memberInfo'))
			});
		}

		this.sendPiwikUrl('withdrawal');

		// 如果有倒计时记录则切换到结果页并开启倒计时
		// if (Cookie("withdrawLastTime") !== null) {
		//     this.setState({ isSuccess: true });
		//     this.startCountDown();
		// }
		this.AllBalance();
		this.getWithdrawBanks();
		this.CCWReminderLogic.initIsWithdrawalCCWDidMountAndAPIDataCompletedPart()
		this.getDepositFrontData(true).then(val=>{
			let isDeposited = val.isDeposited;
			if (!isDeposited) { return; }
			let isOpenPoint = val.isOpenPoint;
			if (isOpenPoint) { return; }
		this.GetPayoutDurations();
		//const newLen2 = this.isFinishFrontData.push(0);
		this.setState({isCannotUseVisible:false}); // reset
		GetWithdrawalMethods((res) => {
			this.setLoading(false, {isList1stLoaded:true});
			let defaultType = (this.props.dialogTabKey && this.props.dialogTabKey.currentPayValue) || this.props.currentWithdrawKey || 'LB';
			if (Array.isArray(res.result.paymentMethods) && res.result.paymentMethods.length) {
				this.DigitalCoinTrait.setAvailableMethod(res.result.paymentMethods.find(_=>_.code==='DCW')?.availableMethods);
				let isPass = true; // this variable is only for Crypto
				let resultArray = [];
				if (Array.isArray(res.result.paymentMethods)) {
					let is1ofValidBankCard = false, is1ofValidKYC = false;
					res.result.paymentMethods.map(v => {
						if (v.isPassedBankCard) { is1ofValidBankCard = true; }
						if (v.isPassedKYC) { is1ofValidKYC = true; }
					})
					if (!is1ofValidBankCard) {
						this.openBankCardModal(1);
						return;
					}
					if (!is1ofValidKYC) {
						this.openKYCModal(1);
						return;
					}
					//////////////////////////////////////////////////////////////
					res.result.paymentMethods.map((e,idx) => {
						const _code = e.code;
						const isCCW = this.isCryptoAlikeUI(_code),
							isCrypto = this.isCryptoFunc(_code),
							isDigital = this.isDigitalFunc(_code),
							IS_FINAL = idx==res.result.paymentMethods.length-1,
							coinTypes = e.availableCoinTypes && e.availableCoinTypes.coinTypes;
						if ((isCrypto && coinTypes && coinTypes.length) || isDigital) {
							if (isCrypto) { isPass = false; }
							this.setState({ [isCrypto ? 'ctcWithdrawType' : (isDigital ? 'digitalcoinWithdrawType' : 'XXXX')]: coinTypes });
							this.isWithdrawalCCWDidMountAndAPIDataCompletedPart1 = true;

							(isCrypto || (isDigital&&coinTypes.length===1)) && this.changeErcTrc(coinTypes[0], isCrypto);
						} else {
							resultArray.push(e);
						}
						this.setState({
							isShowBankCardVerif: res.allowBankcardVerification
						});
						if (IS_FINAL) {
							this.props.setWithdrawList(isPass
								? res.result.paymentMethods.filter(_=>_.code!=='CCW')
								: res.result.paymentMethods,
								defaultType);
						}
					});
				}
			}
			// this.isFinishFrontData.splice(newLen2 - 1, 1, 1);
			// this.isFinishFrontData.length && !~this.isFinishFrontData.indexOf(0) && this.setLoading(false);
			doYouWantToReloadAnyoneDetailMethodWhenDidUpdateWillNotTrigger && this.execGETWithdrawalAnyoneDetailsAndMoreLogic();
		});
		let learnStepString = Cookie('learnStep');
		typeof learnStepString === 'string' &&
			learnStepString.substr(5, 1) === '0' &&
			this.props.setLearnType('withdraw');
		}); // end of .thne(val
	}
	componentDidMount() {
		this.getGD_ICBC();
		this.componentDidMount4Reuse();
	}
	componentDidUpdate(prevProps, prevState) {
		// 当Modal重新打开的时候重新判定是否允许提款
		if (prevProps.visible !== this.props.visible && this.props.visible) {
			this.getWithdrawBanks();
			this.getDepositFrontData(1);

			return;
		}

		if (
			prevState.alreadyBindBanks !== this.state.alreadyBindBanks &&
			this.state.alreadyBindBanks &&
			this.withdrawalBankCardCountPass === false
		) {
			this.getDepositFrontData(2);
			return;
		}

		if ((prevState.isSuccess !== this.state.isSuccess && this.state.isSuccess)
			|| (prevState.tDBisSuccess !== this.state.tDBisSuccess && this.state.tDBisSuccess)
			) {
				this.props.setPromoBannerVisible && this.props.setPromoBannerVisible(false);
		}

		if (prevProps.currentWithdrawKey !== this.props.currentWithdrawKey && this.props.currentWithdrawKey !== '') {
			if (!this.execGETWithdrawalAnyoneDetailsAndMoreLogic) {
			this.execGETWithdrawalAnyoneDetailsAndMoreLogic = () => {
			this.GETWithdrawalAnyoneDetails(this.props.currentWithdrawKey, this.props.currentWithdrawType);
			this.setState({
				tDBSubmitbtnStatus: false,
				withdrawalMoney: '',
				lbWithdrawalDisabledStatus: true,
				tDBisSuccess: false
			});
			if (this.state.isSuccess) this.goWithdrawHome();
			// if (
			//     this.props.currentWithdrawKey !== "CCW" &&
			//     this.state.alreadyBindBanks &&
			//     this.state.alreadyBindBanks.length <= 0
			// ) {
			//     //泰达币提款可以先不用提示添加银行卡，等选中该提款后里面有添加泰达币钱包的地方。
			//     this.getDepositFrontData(3);
			// }
			// USDT 提款第一次进入界面提示汇率相关信息
			if (this.CCWReminderLogic.isNeedToOpenReminderModal()) {
				this.CCWReminderLogic.needToOpenReminderModal(()=>{
				Modal.info({
					className: 'confirm-modal-of-public',
					icon: <div />,
					title: '温馨提醒',
					centered: true,
					okText: '我知道了',

					content: (
						<div className="usdt-exchange-hint">
							<div>
								<img src={'/cn/img/icons/icon-warning.png'} />
							</div>
							<h3 className="title">加密货币提现手续费通知</h3>
							<div className="content">
								<p className="desc">，从 2021-09-22 起，加密货币提款金额超过加密货币充值总额时将会征收手续费。</p>
								<p className="desc">您的加密货币余额将根据您的充值总额减去已提现的总额来进行计算。</p>
								<div
									className="ant-radio-group ant-radio-group-outline"
									onClick={() => {
										this.isChooseNotHint = !this.isChooseNotHint;
										let usdtWithHint = document.getElementById('usdt_with_hint');
										usdtWithHint &&
											(usdtWithHint.className = this.isChooseNotHint
												? 'ant-radio ant-radio-checked'
												: 'ant-radio');
									}}
								>
									<div className="ant-radio-wrapper ant-radio-wrapper-checked">
										<span id="usdt_with_hint" className="ant-radio">
											<input type="radio" className="ant-radio-input" />
											<span className="ant-radio-inner" />
										</span>
										<span>不再提示</span>
									</div>
								</div>
							</div>
						</div>
					),
					onOk: () => {
						this.isChooseNotHint && localStorage.setItem('isFirstUSDTWithdraw', '1');
					}
				});
				});
			} // end of if (this.CCWReminderLogic.isNeedToOpenReminderModal())
			} // end of execGETWithdrawalAnyoneDetailsAndMoreLogic
			} // end of if
			this.execGETWithdrawalAnyoneDetailsAndMoreLogic();
		}
	}

	componentWillUnmount() {
		clearInterval(this.timeTimer);
		clearInterval(this.waitingOpenCCWReminderModalTimer);
	}

	_getCSSStyleWithdrawalMoneyInputWithError() {
		return <style>{`.withdrawal-money-input{border-color:#ff4d4f!important}`}</style>;
	}

	_getInlineCSSWithdrawalMoneyInputWithError() {
		return {margin:'-7px 0px 10px'};
	}

	//提款之前进行验证 是否受到限制，如果被限制 跳转到验证页面
	MemberFlagsStatus = (memberInfo) => {
		let isOpenPoint;
		if (memberInfo && memberInfo.withdrawalVerifyStep && !this.state.ToAccountVerification) {
			isOpenPoint = true;
			this.openPoint();
		}
		return isOpenPoint;
	};

	/**
     *  獲取用戶餘額
     */
	AllBalance() {
		this.setLoading(true);
		GetAllBalance((res) => {
			console.log('GetAllBalance', res);
			if (res.isSuccess && res.result) {
				this.setState(
					{
						balanceList: res.result,
						TotalBal: res.result.find((v) => v.name == 'TotalBal').balance,
						MAINBal: res.result.find((v) => v.name == 'MAIN').balance,
						otherWalletList: res.result.filter(
							(v) => v.state !== 'UnderMaintenance' && v.category !== 'TotalBal' && v.category !== 'Main'
						)
					},
					() => {
						this.calcOtherWalletTotal();
					}
				);
			}
			this.setLoading(false);
		}, undefined, {reqMoreConf:{IS_WITHDRAWAL_API:true}});
	}

	calcOtherWalletTotal = () => {
		const { otherWalletList } = this.state;
		console.log('otherWalletList', otherWalletList);
		if (!otherWalletList.length) {
			this.setState({
				otherWalletTotal: 0
			});
			return;
		}
		const otherBal = otherWalletList.reduce(function(a, b) {
			return { balance: a.balance + b.balance };
		}).balance;

		this.setState({
			otherWalletTotal: otherBal
		});
	};

	// This function might be useless.
	againGetWithdrawalMethods = () => {
		this.setLoading(true);
		this.getWithdrawBanks();
		GetWithdrawalMethods((res) => {
			let defaultType = (this.props.dialogTabKey && this.props.dialogTabKey.currentPayValue) || 'LB';
			if (Array.isArray(res.result) && res.result.length) {
				let isPass = true;
				let resultArray = [];
				Array.isArray(res.result) &&
					res.result.forEach((e) => {
						const isCCW = e.code === 'CCW',
							coinTypes = e.availableCoinTypes && e.availableCoinTypes.coinTypes;
						if (isCCW && coinTypes && coinTypes.length) {
							isPass = false;
							this.setState({ ctcWithdrawType: coinTypes });
							this.props.setWithdrawList(res.result, defaultType);

							this.changeErcTrc(coinTypes[0]);
						} else {
							resultArray.push(e);
						}
						isPass && this.props.setWithdrawList(resultArray, defaultType);
						this.setState({
							isShowBankCardVerif: res.allowBankcardVerification
						});
					});
			}
			this.setLoading(false);
		});
	};
	judgeOTPVerification() {
		// 查询会员是否能够请求短信OTP
		// return this.addExchangeRateWallets()
		this.setState({ isLoading: true });
		let u = this.isDigitalFunc()
				? ApiPort.CheckIsAbleSmsOTPByServiceAction.replace('{serviceAction}', 'DigitalCoin')
				: ApiPort.CheckIsAbleSmsOTP;
		get(u)
			.then((res) => {
				if (res !== undefined) {
					res = res.result;
					this.setState({
						checkAbleSmsOTP: {
							isAbleSmsOTP: res?.isAbleSmsOTP,
							attempts: res?.attempts
						},
						isLoading: false
					});

					!this.state.phoneVisible && this.openNoticeOTP(res);

					if (this.state.phoneVisible && !res?.isAbleSmsOTP) {
						// 驗證彈窗為true，判斷是否能請求sms返回false，關閉驗證彈窗，彈窗超過次數
						this.setState({
							checkAbleSmsOTP: {
								isAbleSmsOTP: res?.isAbleSmsOTP,
								attempts: res?.attempts
							},
							phoneVisible: false,
							exceedVisible: true
						});
					}
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
	isCryptoFunc(code) { return code ? code==='CCW' : this.props.currentWithdrawKey==='CCW' }
	isDigitalFunc(code) { return code ? code==='DCW' : this.props.currentWithdrawKey==='DCW' }
	isCryptoAlikeUI(code) {
		return ['CCW', 'DCW'].includes(code || this.props.currentWithdrawKey)
	}
	getCryptoMemberType() {
		// 判斷泰达币會員類型
		const { isAbleWithdraw, CurrentQuota } = this.state;
		let cryptoMemberType;
		if (this.isCryptoAlikeUI()) {
			if (isAbleWithdraw) {
					if (CurrentQuota === -1) {
						cryptoMemberType = 'Released';
					} else {
						cryptoMemberType = 'Monitoring';
					}
			} else {
				cryptoMemberType = 'Locked';
			}
		}
		this.setState({ cryptoMemberType });
	}
	_getMethodValueFromTypeValue(key, type) {
			return key === 'LB' && type !== 'undefined' ? type : 'DEFAULT';
	}
	GETWithdrawalAnyoneDetails(key, type, conf={}) {
		let IS_INVALID_KEY_TYPE = key==='LB' && type!=='DEFAULT' && DigitalcoinUtil.getKeyOfMethods().includes(type);
		if (IS_INVALID_KEY_TYPE) { // workaround
			return;
		}
		this.isWithdrawalCCWDidMountAndAPIDataCompletedPart2 = false;
		this.setLoading(true);
		const isDigitalFunc = this.isDigitalFunc();
		let method = isDigitalFunc
				? DigitalcoinUtil.getMethodCodeByCoinType(this.state.digitalcoinMethod)
				: this._getMethodValueFromTypeValue(key, type);
		let piwikUrl = '', piwikType= '';
		if (key === 'LB') { piwikUrl = 'withdrawal_lb'; piwikType= 'WITHDRAW_LB'; }
		else if (key === 'CCW') { piwikUrl = 'withdrawal_crypto'; }
		else if (key === 'DCW') { piwikUrl = 'withdrawal_digital_coin'; piwikType='DIGITALCOIN'; }
		const IS_JUST_DIGITAL_COIN_SELECT_CHANGE = conf && conf.is_just_digitalcoin_select_change;
		if (piwikUrl && !IS_JUST_DIGITAL_COIN_SELECT_CHANGE) {
			this.sendPiwikUrl(piwikUrl, piwikType);

			let key4piwik = key==='DCW' ? 'Digital Coin' : key;
			this.sendPiwikEvent('Withdrawal', `Switch to ${key4piwik}`, `Withdrawal_C_${key4piwik}`);
		}
		this.setState({isCannotUseVisible:false}); // reset
		GetWithdrawalMethodsDetail(key, method, (res) => {
            //debugger
			this.setLoading(false, {isAnyoneDetailLoaded:true});
			const setting = res?.result?.setting;
			let isPassedBankCard = setting && setting.isPassedBankCard;
			if (!isPassedBankCard) {
				this.openBankCardModal(2);
				return;
			}

			let isPassedKYC = setting && setting.isPassedKYC;
			if (!isPassedKYC) {
				this.openKYCModal(2);
				return;
			}

			this.isWithdrawalCCWDidMountAndAPIDataCompletedPart2 = true; // <--- put at the line which is no more modal will possibly open at the following lines.

			const isAbleWithdraw = setting?.checkCryptoWithdrawStatus?.isAbleWithdraw;
			if (!isAbleWithdraw) {
				this.setState({isCannotUseVisible: true});
			}

			this.withdrawalLimit = {
				max: res.result.setting.maxBal,
				min: res.result.setting.minBal //非泰达币最大金额
			};

			this.setState(
				{
					minMoney: res.result.setting.minBal,
					maxMoney: res.result.setting.maxBal, //泰达币最大金额
					dayMoney: res.result.setting.dayBal,
					suggestedAmounts: res.result.dynamicObject?.suggestedAmounts,
					isAbleWithdraw: isAbleWithdraw,
					CurrentQuota: res.result.setting.checkCryptoWithdrawStatus.currentQuota,
					IsStaticQuota: res.result.setting.checkCryptoWithdrawStatus.isStaticQuota
				},
				() => {
					this.getCryptoMemberType();
				}
			);
		});
	}
	getEquivalentCoinAmount() {
		this.setLoading(true);
		const datas = {
			CurrencyFrom: 'RMB',
			CurrencyTo: this.state.ctcMethod,
			baseAmount: this.state.withdrawalMoney || '1'
		};
		GetWithdrawalExchangeRate(datas, (res) => {
			this.setLoading(false);
			if (res.isSuccess == true) {
				res = res.result;
				let rateObj = res.tiersExchangeRate;
				let amountObj = res.tiersExchangeAmount;
				let TiersAmountObj = res.tiersAmount;

				this.setState({
					ExchangeRate1: rateObj[1], // 级别1的汇率
					ExchangeRate2: rateObj[2], // 级别2的汇率
					ExchangeAmount1: amountObj[1], // 级别1的金额
					ExchangeAmount2: amountObj[2], // 级别2的金额
					TiersAmount1: TiersAmountObj[1], // 级别2的金额
					TiersAmount2: TiersAmountObj[2], // 级别2的金额
					currencyType: res.currencyFrom,
					ctcMethod: res.currencyTo,
					ConvertedAmount: res.convertedAmount, // 虚拟币等值数量
					WithdrawableBalances: res.withdrawableBalances, // 可免费提现额度
					BalancesUpdatedAt: res.balancesUpdatedAt, // 更新日期
					DepositedAmount: res.depositedAmount, // 充值总金额
					WithdrawAmount: res.withdrawAmount // 提现总额
				});
			} else {
				message.error('汇率获取失败请稍后尝试！');
			}
		});
	}
	// 更改USDT提款币种 || digitalCoinType
	changeErcTrc(type, isCryptoChange=true) {
		const isDigitalChange = !isCryptoChange;
		if (isDigitalChange) {
			CheckDigitalCoinWallet(res => { // In order to fetch walletAddress for making `theDigitalWalletAddress`
				let o = {};
				if (res && Array.isArray(res.result)) {
					o = {aryDigitalCoin: res.result};
				}
				this.setState({...o, ...{withdrawalMoney:'', digitalcoinMethod:type, tDBSubmitbtnStatus:false}});
				this.GETWithdrawalAnyoneDetails(this.props.currentWithdrawKey, type, {is_just_digitalcoin_select_change:true}); // forcly trigger GETWithdrawalAnyoneDetails for digitalcoin here in order to re-fetch min/max value
			})
			return;
		}
		this.changeModalBtnStatus();
		this.setState(
			{
				withdrawalMoney: '',
				ctcMethod: type,
				tDBSubmitbtnStatus: false
			},
			() => {
				this.getEquivalentCoinAmount();
				this.CheckExchangeRateWalletMethod();
			}
		);
	}
	// 查询会员虚拟货币錢包
	CheckExchangeRateWalletMethod() {
		this.setLoading(true);
		const datas = {
			CryptoCurrencyCode: this.state.ctcMethod
		};
		CheckExchangeRateWallet(datas, (res) => {
			this.setLoading(false);
			if (res.result.length) {
				res = res.result;
				let DefaultCard = res.find((ele) => ele.isDefault);
				console.log('DefaultCard:', DefaultCard);
				if (!DefaultCard) {
					this.setDetaultWallet('', res[0]['id']);
					return;
					//当用户没有默认的钱包时给他设置默认第一个钱包为默认钱包
				}
				let notDefaultCard = res.filter((ele) => !ele.isDefault);
				console.log('notDefaultCard:', notDefaultCard);
				let BanksArr = notDefaultCard.length ? [ DefaultCard, ...notDefaultCard ] : [ DefaultCard ];
				console.log('BanksArr:', BanksArr);
				this.setState(
					{
						tDBWalletList: BanksArr
					},
					() => {
						this.showdefaulttDBWallet();
					}
				);
			} else {
				this.setState({ tDBWalletList: [] });
			}
		});
	}

	//设置默认钱包
	setDetaultWallet(event, id) {
		this.setLoading(true);
		const datas = {
			WalletID: id
		};
		setTDBDefaultWallet(datas, (res) => {
			this.setLoading(false);
			if (res.isSuccess == true) {
				this.CheckExchangeRateWalletMethod();
			}
		});
		Pushgtagdata('Default_TDBWallet_profilepage');
	}

	goWithdrawHome() {
		this.setState({ isSuccess: false });
		Cookie('withdrawLastTime', null);
		clearInterval(this.timeTimer);
		this.setState({ lBWithdrawalFlag: false }, () => {
			this.getWithdrawBanks();
		});
	}
	startCountDown() {
		clearInterval(this.timeTimer);
		const cookieWithdrawLastTime = Cookie('withdrawLastTime');
		if (cookieWithdrawLastTime === null) return;
		const withdrawDateTime = cookieWithdrawLastTime.replace('-', '/').replace('-', '/');
		let lastSeconds = 1800;
		withdrawDateTime !== null && withdrawDateTime !== ''
			? (this.timeTimer = setInterval(() => {
					if (lastSeconds <= 0) {
						this.goWithdrawHome();
					}
					this.setState({
						remainingTime: formatSeconds(lastSeconds--)
					});
				}, 1000))
			: Cookie('withdrawLastTime', null);
	}
	fnIsBankUpgradingError(curBank = {}) {
		let isICBC = false, isGuangDong = false, aryCheck;
		aryCheck = Array.isArray(this.icbcBankname) ? this.icbcBankname : [];
		aryCheck = aryCheck.concat( this.defaultIcbcBankname.filter(v=>!aryCheck.includes(v)) );
		if (Array.isArray(aryCheck)) {
		for (let check of aryCheck.map(v=>v.toLowerCase())) {
			for (let field of ['bankName', 'bankNameEn', 'bankNameLocal',    'BankName', 'BankNameEn', 'BankNameLocal']) {
				let value = curBank && curBank[field] && typeof curBank[field]==='string' ? curBank[field].toLowerCase() : '';
				if (value.includes(check)) { isICBC = true; break; }
			}
			if (isICBC) { break; }
		}
		} // end of if
		aryCheck = Array.isArray(this.gdProvince) ? this.gdProvince : [];
		aryCheck = aryCheck.concat( this.defaultGdProvince.filter(v=>!aryCheck.includes(v)) );
		if (Array.isArray(aryCheck)) {
		for (let check of aryCheck.map(v=>v.toLowerCase())) {
			for (let field of ['province', 'Province']) {
			let value = curBank && curBank[field] && typeof curBank[field]==='string' ? curBank[field].toLowerCase() : '';
			if (value.includes(check)) { isGuangDong = true; break; }
			}
		}
		} // end of if
		return isICBC && isGuangDong;
	}
	changeBankCard(v) {
		if (v === -1) return;
		let curBank = Array.isArray(this.state.alreadyBindBanks) && this.state.alreadyBindBanks.length
						? this.state.alreadyBindBanks[v]
						: {};
		let isBankUpgradingError = this.fnIsBankUpgradingError(curBank);
		this.setState({ defaultBankCardId: v, isBankUpgradingError}, () => {
			this.getLBWithdrawalSetUp();
		});
	}
	goBankAccount() {
		const PAGE_TARGET = 'bankaccount';
		if (~global.location.pathname.indexOf('/cn/usercenter')) {
			this.props.onCancel();
			sessionStorage.getItem('userCenterPageKey') !== PAGE_TARGET && global.goPage(PAGE_TARGET);
		} else {
			sessionStorage.setItem('userCenterPageKey', PAGE_TARGET);
			Router.push('/cn/usercenter');
		}
	}

	goRecords() {
		let PAGE_TARGET = 'records';
		if (~global.location.pathname.indexOf('/cn/usercenter')) {
			this.props.onCancel();
			sessionStorage.setItem('selectTabKey', 'withdraw');
			sessionStorage.getItem('userCenterPageKey') !== PAGE_TARGET && global.goPage(PAGE_TARGET);
			typeof global.changeRecordFilterType === 'function' && global.changeRecordFilterType('withdraw');
		} else {
			sessionStorage.setItem('userCenterPageKey', PAGE_TARGET);
			sessionStorage.setItem('selectTabKey', 'withdraw');
			Router.push('/cn/usercenter');
		}
		this.setState({
			tDBisSuccess: false,
			tDBSubmitbtnStatus: false,
			withdrawalMoney: '',
			isSuccess: false,
			ctcMethod: '',
			lbWithdrawalDisabledStatus: true
		});
	}

	handleSubmit = (e) => {
		e.preventDefault();
		if (this.isDigitalFunc()) {
			let theWallet = this.getSelectedDigitalCoinWallet();
			this.submitPay({
				accountNumber: theWallet.walletAddress,
				accountHolderName: theWallet.walletName,
				language: "zh-CN",
				paymentMethod: "DCW",
				amount: this.state.withdrawalMoney,
				transactionType: "Withdrawal",
				isMobile: false,
				isSmallSet: false,
				mgmtRefNo: "Fun88Desktop",
				swiftCode: "Fun88Desktop",
				bonusId: 0,
				merchantType: 0,
				methodCode: DigitalcoinUtil.getMethodCodeByCoinType(this.state.digitalcoinMethod),
				convertedCurrency: this.state.digitalcoinMethod,
				cryptoCoinType: this.state.digitalcoinMethod,
			});
			return;
		}
		// 对于会员银行卡未获取完成的情况不做任何操作
		if (this.state.alreadyBindBanks === '') return;
		if (!this.state.withdrawalMoney && this.props.currentWithdrawKey == 'LB') {
			return message.error('请选择存款金额。');
		}
		// if (!this.isAllowWithdraw) {
		// 	// 未充值
		// 	return this.openPoint(this.withdrawalPromptId);
		// } else
		if (!this.state.memberInfo.isDeposited) {
			return this.openDeposit();
		} else if (
			this.state.alreadyBindBanks &&
			this.state.alreadyBindBanks.length <= 0 &&
			this.props.currentWithdrawKey != 'CCW'
		) {
			// 未完善并验证信息
			return this.openFinishBankCard();
		} // 未完善银行账户
		if (
			this.props.currentWithdrawKey === 'LB' &&
			this.state.isShowLBWithdrawalTip !== '' &&
			!this.state.lBWithdrawalFlag
		) {
			this.setState({ isShowLBWithdrawalModal: true });
		} else {
			this.props.form.validateFields((err, values) => {
				if (!err) {
					let postData = {};
					const { alreadyBindBanks, defaultBankCardId, defaultWithdrawMethod } = this.state;
					switch (this.props.currentWithdrawKey) {
						case 'LB':
							postData = {
								accountHolderName: alreadyBindBanks[defaultBankCardId].accountHolderName,
								accountNumber: alreadyBindBanks[defaultBankCardId].accountNumber,
								bankAccountId: alreadyBindBanks[defaultBankCardId].bankAccountID,
								amount: values.money,
								bankName: alreadyBindBanks[defaultBankCardId].bankName,
								branch: alreadyBindBanks[defaultBankCardId].branch,
								charges: 0,
								city: alreadyBindBanks[defaultBankCardId].city,
								domainName: ApiPort.LOCAL_HOST,
								isMobile: false,
								isSmallSet: false,
								language: 'zh-cn',
								paymentMethod: this.props.currentWithdrawKey,
								province: alreadyBindBanks[defaultBankCardId].province,
								shouldSaveBank: false,
								swiftCode: alreadyBindBanks[defaultBankCardId].SWIFTCode,
								transactionType: 'Withdrawal',
								method: 'LB',
								methodCode: 'DEFAULT',
								maxPayoutDurationInMins:
									this.state.AllpayoutDurations.length === 1
										? this.state.AllpayoutDurations[0].maxDurationInMins
										: this.state.maxPayoutDurationInMins,
								payoutDurationRebatePercent:
									this.state.AllpayoutDurations.length === 1
										? this.state.AllpayoutDurations[0].payoutDurationRebatePercent
										: this.state.payoutDurationRebatePercent
							};
							break;
						case 'SW':
							postData = {
								accountHolderName: alreadyBindBanks[defaultBankCardId].accountHolderName,
								accountNumber: alreadyBindBanks[defaultBankCardId].accountNumber,
								bankAccountId: alreadyBindBanks[defaultBankCardId].bankAccountID,
								amount: values.money,
								bankName: alreadyBindBanks[defaultBankCardId].bankName,
								branch: alreadyBindBanks[defaultBankCardId].branch,
								charges: 0,
								city: alreadyBindBanks[defaultBankCardId].city,
								domainName: ApiPort.LOCAL_HOST,
								isMobile: false,
								isSmallSet: false,
								language: 'zh-cn',
								paymentMethod: this.props.currentWithdrawKey,
								province: alreadyBindBanks[defaultBankCardId].province,
								shouldSaveBank: false,
								swiftCode: alreadyBindBanks[defaultBankCardId].SWIFTCode,
								transactionType: 'Withdrawal',
								method: 'LB',
								methodCode: 'DEFAULT'
							};
							break;
						case 'APW':
							postData = {
								accountNumber: this.state.phone,
								amount: values.money,
								charges: 0,
								domainName: ApiPort.LOCAL_HOST,
								isMobile: false,
								isSmallSet: false,
								language: 'zh-cn',
								paymentMethod: this.props.currentWithdrawKey,
								swiftCode: 'rb88',
								transactionType: 'Withdrawal'
							};
							break;
						case 'CCW':
							postData = {
								accountNumber: this.state.selectTDBAddress,
								accountHolderName: this.state.selectTDBName,
								language: 'zh-cn',
								paymentMethod: this.props.currentWithdrawKey,
								amount: this.state.withdrawalMoney,
								transactionType: 'Withdrawal',
								isMobile: false,
								isSmallSet: false,
								ConvertedCurrency: this.state.ctcMethod
							};
                            break
						default:
							break;
					}
					if (this.props.currentWithdrawKey === 'LB') {
						// if (
						//     Array.isArray(this.state.suggestedAmounts) &&
						//     this.state.suggestedAmounts.length &&
						//     this.state.suggestedAmounts.every(
						//         (item) => item.amount !== values.money
						//     )
						// ) {
						//     this.getClosedPrefixAmount(postData);
						// } else {
						this.submitPay(postData);
						// }
					} else {
						this.submitPay(postData);
					}
				}
			});
		}

		switch (this.props.currentWithdrawKey) {
			case 'LB':
				Pushgtagdata('Withdrawal', 'Submit', 'Submit_LB_Withdraw');
				break;
			case 'CCW':
				Pushgtagdata('Withdrawal', 'Submit', 'Submit_Crypto_Withdraw');
				break;
			case 'APW':
				Pushgtagdata('Withdrawal', 'Submit', 'Submit_APW_Withdraw');
				break;
		}
	};
	/**
     * 提交提现
     * @param {Object} postData //提交提现所需的参数
     */
	submitPay = (postData) => {
		this.setLoading(true);
		CommonPostPay(postData, (res) => {
			this.setLoading(false);
			// piwik START
			const evtValue = res?.isSuccess ? '2' : '1', aryCustomVariable = [];
			let ErrorMsg = res?.errors?.[0]?.errorCode + '|' + res?.errors?.[0]?.description;
			if (res?.isSuccess) { ErrorMsg = ''; }
			switch (this.props.currentWithdrawKey) {
				case 'LB':
					aryCustomVariable.push({customVariableKey:'Withdrawal_LB_S_Withdraw_Amount', customVariableValue:postData.amount});
					if (ErrorMsg) {
					aryCustomVariable.push({customVariableKey:'Withdrawal_LB_S_Withdraw_ErrorMsg', customVariableValue:ErrorMsg});
					}
					this.sendPiwikEventWithEventValue(
						'Withdrawal', 'Submit Withdrawal (LB)', 'Withdrawal_LB_S_Withdrawal',
						evtValue, aryCustomVariable);
					break;
				case 'CCW':
					aryCustomVariable.push({customVariableKey:'Withdrawal_Crypto_S_Withdraw_Amount', customVariableValue:postData.amount});
					if (ErrorMsg) {
					aryCustomVariable.push({customVariableKey:'Withdrawal_Crypto_S_Withdraw_ErrorMsg', customVariableValue:ErrorMsg});
					}
					this.sendPiwikEventWithEventValue(
						'Withdrawal', 'Submit Withdrawal (Crypto)', 'Withdrawal_Crypto_S_Withdrawal',
						evtValue, aryCustomVariable);
					break;
				case 'DCW':
					let COIN_TYPE = DigitalcoinUtil.getMethodCodeByCoinType(this.state.digitalcoinMethod) || 'COINTYPE';
					aryCustomVariable.push({customVariableKey:'Withdrawal_'+COIN_TYPE+'_S_Withdraw_Amount', customVariableValue:postData.amount});
					if (ErrorMsg) {
					aryCustomVariable.push({customVariableKey:'Withdrawal_'+COIN_TYPE+'_S_Withdraw_ErrorMsg', customVariableValue:ErrorMsg});
					}
					this.sendPiwikEventWithEventValue(
						'Withdrawal', 'Submit Withdrawal '+COIN_TYPE, 'Withdrawal_'+COIN_TYPE+'_S_Withdrawal',
						evtValue, aryCustomVariable);
					break;
			}
			// piwik END

			if (res.isSuccess == true) {
				if (this.isCryptoAlikeUI()) {
					this.setState({
						tDBisSuccess: true,
						tDBisSuccessId: res.result.transactionId,
						isSuccess: false
					});
					Cookie('withdrawLastTime', null);
				} else {
					this.setState({ isSuccess: true });
					Cookie('withdrawLastTime', dateFormat());
					this.startCountDown();
					if (this.props.currentWithdrawKey === 'LB') {
						this.setState({
							lbMethodsResult: res.result,
							payoutMode: res.result.payoutMode,
							rebateAmount: res.result.rebateAmount,
							transactionId: res.result.transactionId,
							withdrawalTime: res.result.maxPayoutDurationInMins
						});
					}
				}
				this.props.form.resetFields();
				this.props.getBalance();
			}
			if (
				res.result &&
				typeof res.result.bonusApplicationMessage === 'string' &&
				res.result.bonusApplicationMessage != ''
			) {
				message.error(res.result.bonusApplicationMessage);
			}
			if (res.errors != '') {
				res.errorCode = res.errors[0].errorCode;
				res.description = res.errors[0].description;

				if (res.errors && res.errors[0].errorCode == 'P106003') {
					Modal.info({
						title: '温馨提醒',
						icon: <div />,
						centered: true,
						className: `confirm-modal-of-public`,
						footer: null,
						type: 'confirm',
						okText: '马上验证',
						onlyOKBtn: true,
						width: '322px',
						onOk: () => {
							this.PostAccountHolderName(postData.accountHolderName);
						},
						content: (
							<React.Fragment>
								<center>
									<img src="/cn/img/icons/icon-warn.svg" />

									<h3 style={{ marginTop: '15px' }}>
										<b>进行账户验证</b>
									</h3>
									<p
										style={{
											padding: '10px 0px 0px',
											lineHeight: '20px'
										}}
									>
										您已达到最高提款金额，请验证您的账户
									</p>
								</center>
							</React.Fragment>
						)
					});
					return;
				}

				if (res.errors && res.errors[0].errorCode == 'SNC0001') {
					Modal.info({
						title: '温馨提醒',
						icon: <div />,
						centered: true,
						className: `confirm-modal-of-public`,
						footer: null,
						type: 'confirm',
						okText: '马上验证',
						onlyOKBtn: true,
						width: '322px',
						onOk: () => {
							this.PostAccountHolderName(postData.accountHolderName);
						},
						content: (
							<React.Fragment>
								<center>
									<img src="/cn/img/icons/icon-warn.svg" />
									<br />
									<h3 style={{ marginTop: '15px' }}>
										<b>验证您的身份</b>
									</h3>
									<p
										style={{
											padding: '10px 0 25px 0px',
											lineHeight: '20px'
										}}
									>
										系统检测到您的注册名字与提款银行帐户名称之间存在差异。 请在个人资料 -“上传文件页面” 上传所需文件以验证您的身份，或联系在线客服寻求协助。
									</p>
									<div
										style={{
											lineHeight: '20px',
											paddingBottom: '20px'
										}}
									>
										<p>
											提款账户名：
											{postData.accountHolderName}
										</p>
										<p>
											注册姓名：
											{this.state.memberInfo.firstName}
										</p>
									</div>
								</center>
							</React.Fragment>
						)
					});
					return;
				}

				if (res.errors && res.errors[0].errorCode == 'SNC0002') {
					Modal.info({
						title: '温馨提醒',
						icon: <div />,
						centered: true,
						className: `confirm-modal-of-public`,
						footer: null,
						type: 'confirm',
						okText: '马上验证',
						onlyOKBtn: true,
						width: '322px',
						onOk: () => {
							this.props.goUserCenter('uploadFiles');
						},
						onCancel: () => {},
						content: (
							<React.Fragment>
								<center>
									<img src="/cn/img/icons/icon-warn.svg" />

									<h3 style={{ marginTop: '15px' }}>
										<b>身份验证所需文件</b>
									</h3>
									<p
										style={{
											padding: '10px 0 25px 0px',
											lineHeight: '20px'
										}}
									>
										我们注意到您帐户存在异常。 请在个人资料-“上传文件页面”上传所需文件以验证您的身份，或联系在线客服寻求协助。
									</p>
								</center>
							</React.Fragment>
						)
					});
					return;
				}

				if (res.errors && res.errors[0].errorCode == 'SNC0003') {
					Modal.info({
						title: '温馨提醒',
						icon: <div />,
						centered: true,
						className: `confirm-modal-of-public`,
						footer: null,
						type: 'confirm',
						okText: '知道了',
						onlyOKBtn: true,
						width: '322px',
						onOk: () => {
							//this.PostAccountHolderName(Bank.accountHolderName);
						},
						content: (
							<React.Fragment>
								<center>
									<img src="/cn/img/icons/icon-warn.svg" />

									<h3 style={{ marginTop: '15px' }}>
										<b>待验证</b>
									</h3>
									<p
										style={{
											padding: '10px 0 25px 0px',
											lineHeight: '20px'
										}}
									>
										请耐心等待，您的新银行帐户名称正在验证中。如需了解更多详情，请联系 在线客服 寻求协助。
									</p>
								</center>
							</React.Fragment>
						)
					});
					return;
				}

				if (res.errors && res.errors[0].errorCode == 'P101103') {
					Modal.info({
						className: 'confirm-modal-of-public',
						icon: <div />,
						title: '重要提示',
						width: 355,
						okText: '好的',
						okButtonProps: {
							shape: 'round'
						},

						content: (
							<div className="exchange-hint">
								<div className="content" style={{ textAlign: 'center' }}>
									<p>请耐心等待，您有一项提款申请正在处理中</p>
									<div className="OrderContent">
										<p>
											提款编号：
											{res.result.lastWithdrawalID}
										</p>
										<p>提款金额：￥ {formatAmount(res.result.lastWithdrawalAmount)}</p>
									</div>
									<p>请等待处理完毕后，再提交其他提款申请</p>
								</div>
							</div>
						)
					});
				} else if (!res.isSuccess && this.props.currentWithdrawKey === 'LB' && res.errorCode === 'SR99999') {
					Modal.info({
						title: '',
						okText: '我知道了',
						centered: true,
						content: (
							<div>
								{' '}
								，因请求异常导致您的提现未能成功，请重新提交或
								<Button type="link" onClick={global.PopUpLiveChat}>
									联系在线客服！
								</Button>
							</div>
						)
					});
				} else {
					// res.description.length > 10
					// 	? message.error(res.description)
					// 	: Modal.info({
					// 			title: '温馨提示',
					// 			centered: true,
					// 			okText: '确认',
					// 			content: res.description
					// 		});
					message.error(res.errors[0].description, 2);
				}
				Cookie('withdrawLastTime', null);
			} else {
				this.setState({ isSuccess: true });
				Cookie('withdrawLastTime', dateFormat());
				// this.startCountDown();
			}
		});
		// switch (this.props.currentWithdrawKey) {
		//     case "LB":
		//         Pushgtagdata(
		//             "Withdrawal",
		//             "Submit",
		//             "Submit_LocalBank_Withdrawal"
		//         );
		//         break;
		//     default:
		//         Pushgtagdata("Submit_withdrawal_wallet");
		//         break;
		// }
	};

	/**
     * @description: 跳转去文件验证页面 先传递 银行账户持有人名称
     * @param {*} accountHolderName  银行账户持有人名称
     * @return {*}
     */

	PostAccountHolderName(accountHolderName) {
		post(ApiPort.AccountHolderName + `&bankHolderName=${accountHolderName}&`)
			.then((res) => {
				this.props.onCancel();
				this.props.goUserCenter('uploadFiles');
			})
			.catch((error) => {
				this.props.onCancel();
				this.props.goUserCenter('uploadFiles');
			});
	}

	getWithdrawBanks() {
		this.setLoading(true);
		//const newLen = this.isFinishFrontData.push(0);
		GetMemberBanks((res) => {
			if (Array.isArray(res.result)) {
				let defaultId = res.result.length ? 0 : -1;
				res.result.some((val, index) => {
					if (val.isDefault) {
						defaultId = index;
						return true;
					}
				});
				let alreadyBindBanks = res.result;
				let isBankUpgradingError = Array.isArray(alreadyBindBanks) && alreadyBindBanks.length
											? this.fnIsBankUpgradingError(alreadyBindBanks[defaultId])
											: false;
				this.setState(
					{
						defaultBankCardId: defaultId,
						isBankUpgradingError,
						alreadyBindBanks
					},
					() => {
						if (res.result && res.result.length) {
							//如果有提款银行卡才执行查询
							this.getLBWithdrawalSetUp();
						}
					}
				);
			}

			// this.isFinishFrontData.splice(newLen - 1, 1, 1);
			// this.isFinishFrontData.length && !~this.isFinishFrontData.indexOf(0) && this.setLoading(false);
		});
	}
	//查询用户银行卡是否被限制
	getLBWithdrawalSetUp() {
		// this.setLoading(true);
		let data = {
			BankAccountId: this.state.alreadyBindBanks[this.state.defaultBankCardId].bankAccountID
			// BankAccountNumber:this.state.alreadyBindBanks[this.state.defaultBankCardId].AccountNumber,
		};
		getWithdrawalSetUp(data, (res) => {
			// this.setLoading(false);
			if (res.description && res.description !== '' && res.descriptionCode !== '') {
				this.setState({
					isShowLBWithdrawalTip: res.description,
					isLBDescriptionCode: res.descriptionCode
				});
			} else {
				this.setState({ isShowLBWithdrawalTip: '' });
			}
		});
	}

	// 获取提款前置信息（会员信息完善情况）
	getDepositFrontData(status) {
		return new Promise(resolve=>{
		this.setLoading(true);

		getMemberInfo((res) => {
			this.setState({
				memberInfo: res
			});
			if (res.isDeposited === 0) {
				resolve({isDeposited: res.isDeposited});
				this.openDeposit(true);
				return;
			}
			const isOpenPoint = this.MemberFlagsStatus(res);
			resolve({isDeposited: res.isDeposited, isOpenPoint});

			this.setLoading(false);

			// if (this.state.alreadyBindBanks === '') {
			// 	this.withdrawalBankCardCountPass = false;
			// 	return;
			// } else {
			// 	this.withdrawalBankCardCountPass = true;
			// }

			// 呼出提款限制提示（1、必须充值 2、必须完善并验证会员信息 3、必须完善银行卡）
			// if (this.state.alreadyBindBanks && this.state.alreadyBindBanks.length <= 0) {
			// 	// 对于提款卡未加载完成 或者 未添加提款卡的会员都提示添加银行卡
			// 	this.isAllowWithdraw = true;
			// 	this.props.currentWithdrawKey != 'CCW' &&
			// 		this.props.currentWithdrawKey !== '' &&
			// 		this.openFinishBankCard(); //泰达币提款不需要默认先添加银行卡，其他方式需要
			// } else {
			// 	this.isAllowWithdraw = true;

			// 	// this.setState({
			// 	// 	userInfo: {
			// 	// 		userName: res.userName,
			// 	// 		currency: res.currency,
			// 	// 		memberCode: res.memberCode,
			// 	// 		isDeposited: res.isDeposited,
			// 	// 		realyName: res.firstName,
			// 	// 		cardId: res.documentID,
			// 	// 		isBankCardValidated: res.isBankCardValidated,
			// 	// 		phoneNumber: phoneNumber,
			// 	// 		phoneStatus: phoneStatus
			// 	// 	}
			// 	// });
			// }
		}, true);
		});
	}
	openDeposit() {
		Modal.confirm({
			className: 'confirm-modal-of-public',
			icon: <div />,
			title: '温馨提示',
			centered: true,
			okText: '立即存款',
			cancelText: '取消',
			content: '您还未存款，提款前请先进行存款和游戏。',
			onOk: () => {
				// 当前往充值的时候需要关闭提款的教程界面
				this.props.setLearnType('');
				// 提款窗口呼出充值窗口的方法有两种（1、调用父组件传递进来的方法 2、调用全局的呼出充值方法窗口），此处采用父组件传递的方法！
				this.props.goDeposit('deposit');
			},
			onCancel: () => {
				this.props.onCancel();
			}
		});
	}
	openPoint() {
		Modal.confirm({
			className: 'confirm-modal-of-public',
			icon: <div />,
			title: '安全认证',
			centered: true,
			okText: '立即验证',
			cancelText: '取消提款',
			content: (
				<div style={{ textAlign: 'left' }}>
					<h4>
						<b>为了您的账户安全，请先完成以下认证：</b>
					</h4>
					<p>• 验证身份证号码</p>
					<p>• 完善个人资料 </p>
					<p>• 验证手机号</p>
					<p>• 验证电子邮箱</p>
				</div>
			),
			onOk: () => {
				// this.props.onCancel();
				this.setState({
					ToAccountVerification: true
				});
			},
			onCancel: () => {
				this.props.onCancel();
				this.setState({
					ToAccountVerification: false
				});
			}
		});
	}

	openFinishBankCard() {
		Modal.info({
			title: '暂无提款卡',
			centered: true,
			okText: '立即前往',
			content: '请到银行账户添加提款卡',
			onOk: () => {
				this.props.onCancel();
				this.props.goUserCenter('bankaccount');
			},
			onCancel: () => {
				this.props.onCancel();
			}
		});
	}

	openNoticeOTP(res) {
		// 需要OTP驗證通知匡
		if (res?.attempts && res?.isAbleSmsOTP) {
			// 判斷是否有次數，若無，超過次數彈窗
			Modal.confirm({
				className: 'blueHeaderModal closable-hide',
				icon: <div />,
				title: '账户验证',
				icon: null,
				centered: true,
				okText: '立即验证',
				cancelText: '稍后再说',
				content: <div style={{ textAlign: 'center' }}>亲爱的会员，为了确保您的账户安全，在添加钱包地址之前，请先完成电话验证。</div>,
				onOk: () => {
                    this.setState({ phoneVisible: true }, ()=>{
                        if (this.isCryptoFunc()) {
                        this.sendPiwikUrl('withdrawal_crypto_phone_verification')
                        }
                    });
					if (this.isCryptoFunc()) {
					Pushgtagdata('Continue_TTH_Crypto');
					}
				},
				onCancel: () => {
					if (this.isCryptoFunc()) {
					Pushgtagdata('Leave_TTH_Crypto');
					}
				}
			});
		} else {
			this.setState({ exceedVisible: true });
		}
	}
	sendPiwikEventWithEventValue(category, action, name, evtValue, aryCustomVariable) {
		global.PushgtagdataWithEventValue && global.PushgtagdataWithEventValue(category, action, name, evtValue, aryCustomVariable);
	}
	sendPiwikEvent(category, action, name) {
		global.Pushgtagdata && global.Pushgtagdata(category, action, name);
	}
	sendPiwikUrl(url, type='') {
		let title = 'Withdrawal';
		if (type=='ACCOUNT') { title='Withdrawal Account'; }
		if (type=='WITHDRAW_LB') { title='Withdrawal LB'; }
		if (type=='DIGITALCOIN') { title='DigitalCoin Withdrawal Page'; }
		global.Pushgtagpiwikurl && global.Pushgtagpiwikurl(url, title);
	}
	openBankCardModalCancelFunc(at) {
		this.setState({isCannotUseVisible:true});
		/*
		const IS_1st_LAYER = at===1;
		const IS_2nd_LAYER = at===2;
		IS_1st_LAYER && global.hideWalletModal();
		IS_2nd_LAYER && this.setState({isCannotUseVisible:true});
		*/
	}
	openBankCardModal(at=0, paymentMethod='') {
		const IS_1st_LAYER = at===1;
		const IS_2nd_LAYER = at===2;
		IS_2nd_LAYER && this.sendPiwikUrl('withdrawal_account_add_bank_popup', 'ACCOUNT');
		IS_1st_LAYER && this.sendPiwikUrl('withdrawal_account_add_bank_or_left_popup', 'ACCOUNT');
		Modal.confirm({
			className: "blueHeaderModal",
			wrapClassName: "blueHeaderModal",
			title: "温馨提醒",
			icon: null,
			centered: true,
			okText: "立即前往",
			cancelText: IS_2nd_LAYER ? "稍后再说" : "离开",
			content: (
				<div style={{ textAlign: "center" }}>
					您尚未添加提款银行信息，请先添加后再进行提款。
				</div>
			),
			onOk: () => {
				this.setState({isAddBankAccountModalVisible: true, whenAddBankAccountModalVisibleTrueAt:at});
			},
			onCancel: () => {
				this.openBankCardModalCancelFunc(at);
			},
		});
	}
	openKYCModal(at=0, paymentMethod='') {
		const IS_1st_LAYER = at===1;
		const IS_2nd_LAYER = at===2;
		IS_2nd_LAYER && this.sendPiwikUrl('withdrawal_account_kyc_cs_popup', 'ACCOUNT');
		IS_1st_LAYER && this.sendPiwikUrl('withdrawal_account_kyc_cs_or_left_popup', 'ACCOUNT');
		Modal.confirm({
			className: "blueHeaderModal",
			wrapClassName: "blueHeaderModal",
			title: "温馨提醒",
			icon: null,
			centered: true,
			okText: "联系客服",
			cancelText: IS_2nd_LAYER ? "稍后再说" : "离开",
			content: (
				<div style={{ textAlign: "center" }}>
					您的账户资料尚未完善，请联系客服进行验证后再提款
				</div>
			),
			onOk: () => {
				global.PopUpLiveChat(true);
				IS_1st_LAYER && global.hideWalletModal();
				IS_2nd_LAYER && this.setState({isCannotUseVisible:true});
			},
			onCancel: () => {
				IS_1st_LAYER && global.hideWalletModal();
				IS_2nd_LAYER && this.setState({isCannotUseVisible:true});
			},
		});
	}

	leaveWalletButtonHandle(pram) {
		let isCryptoFunc = this.isCryptoFunc();
		// 離開添加錢包控制
		if (pram) {
			this.setState({ leaveAddWalletVisible: false });
			if (isCryptoFunc) {
			Pushgtagdata('Continue_TTH_Crypto');
			}
		} else {
			if (isCryptoFunc) {
			Pushgtagdata('Leave_TTH_Crypto');
			}
			this.setState({
				leaveAddWalletVisible: false, // 再次確認是否離開添加錢包
				[isCryptoFunc ? 'visibleExchangeRateWallet' : 'visibleDigitalCoinWallet']: false,
				tDBName: '',
				tDBAddress: '',
				addTDBBtnStatue: false
			});
		}
	}

	getVerificationCode(v) {
		this.setState({ verificationCode: v });
	}

	handleOk(opt={}) {
		this.setLoading(true);
		const isCryptoFunc = this.isCryptoFunc();
		const isDigitalFunc = this.isDigitalFunc();
		this.setState({ [isCryptoFunc ? 'visibleExchangeRateWallet' : 'visibleDigitalCoinWallet']: false });
		const datas = isCryptoFunc ? {
			walletName: this.state.tDBName,
			walletAddress: this.state.tDBAddress,
			cryptocurrencyCode: this.state.ctcMethod,
			isDefault: 'false',
			type: 'CryptoCurrency',
			passCode: this.state.verificationCode
		} : {
			walletName: DigitalcoinUtil.getHardCodeNameByCoinType(this.state.tDBName),
			walletAddress: this.state.tDBAddress,
			cryptocurrencyCode: opt?.curCoinType,
			isDefault: true,
			type: "DigitalCoin",
			passCode: this.state.verificationCode,
		};
		AddExchangeRateWallets(datas, (res) => {
			this.setLoading(false);
			let IS_ALL_SUCCESS = res?.isSuccess;
            if (res && res.result && typeof res.result.isSuccess!=='undefined') {
                IS_ALL_SUCCESS = IS_ALL_SUCCESS && res.result.isSuccess;
            }
			if (IS_ALL_SUCCESS) {
				this.showInfoModal('添加成功');
				isCryptoFunc && this.CheckExchangeRateWalletMethod();
				isDigitalFunc && CheckDigitalCoinWallet(res => {
						if (res && Array.isArray(res.result)) {
							this.setState({aryDigitalCoin: res.result})
						}
					});
				this.setState({
					tDBName: '',
					tDBAddress: '',
					addTDBBtnStatue: false
				});
			} else {
				if (res.result?.walletAddressErrorList.length) {
					message.error(res.result?.walletAddressErrorList[0].description);
				} else if (res.result?.walletNameErrorList.length) {
					message.error(res.result?.walletNameErrorList[0].description);
				} else {
					message.error(res.message || res.result?.message || 'Add wallet fail.');
				}
			}
		});
	}
	addExchangeRateWallets() {
		this.setState({ visibleExchangeRateWallet: true }, () => {
			this.sendPiwikUrl('withdrawal_crypto_add_wallet')
		});
	}
	digitalCoinWalletRegExpTest = (evt, t, opt={}) => {
		this.exchangeRateWalletTest(evt, t, opt)
	}
	exchangeRateWalletTest = (e, t, opt={}) => {
		const walleNametTest = /^[\u4e00-\u9fa5\u0E00-\u0E7F\a-zA-Z0-9]{1,20}$/;
		const walleAddressTest =
			this.state.ctcMethod === 'USDT-ERC20' ? /^(0x|0X)[a-zA-Z0-9]{40}$/ : /^T[a-zA-Z0-9]{33}$/;
		const walleAddressTest2 =
			/^[\u4e00-\u9fa5\u0E00-\u0E7F\a-zA-Z0-9]{1,50}$/;
		const is_cointype = t == 'cointype';
		let value = is_cointype ? e : e.target.value;
		if (is_cointype) {
			this.setState({ tDBName:value, tDBNameError: !!value
				, tDBAddress: '', tDBAddressError2: this.DEFAULT_ERROR_BOOLEAN, tDBAddressErrorDigitalCoin:this.DEFAULT_ERROR_BOOLEAN }, //<--remeber reset Address to empty string
				() => {
				this.changeModalBtnStatus();
			});
		}
		if (t == 'name') {
			this.setState({ tDBName: value }, () => {
				if (walleNametTest.test(value) === false) {
					this.setState({ tDBNameError: false }, () => {
						this.changeModalBtnStatus();
					});
				} else {
					this.setState({ tDBNameError: true }, () => {
						this.changeModalBtnStatus();
					});
				}
			});
		}
		if (t == 'address') {
			let isDigitalFunc = this.isDigitalFunc();
			let _tDBAddressError2 = value && (isDigitalFunc ? /^[a-zA-Z0-9]+$/.test(value) : walleAddressTest2.test(value));
			this.setState({ tDBAddress: value, tDBAddressError2: _tDBAddressError2 }, () => {
				let _walleAddressRegExp = walleAddressTest;
				if (isDigitalFunc) {
					_walleAddressRegExp = null;
					if (opt?.curCoinType) {
						_walleAddressRegExp = DigitalcoinUtil.WALLET_REGEXP_MAP[opt?.curCoinType] || null;
					}
				}
				if (_walleAddressRegExp && _walleAddressRegExp.test(value) === false) {
					this.setState({ [isDigitalFunc ? 'tDBAddressErrorDigitalCoin' : 'tDBAddressError']: false }, () => {
						this.changeModalBtnStatus();
					});
				} else {
					this.setState({ [isDigitalFunc ? 'tDBAddressErrorDigitalCoin' : 'tDBAddressError']: true }, () => {
						this.changeModalBtnStatus();
					});
				}
			});
		}
	};
	changeModalBtnStatus() {
		const { tDBNameError, tDBAddressError /*for CCW */ , tDBAddressErrorDigitalCoin /*for DCW*/ , tDBAddress, tDBName } = this.state;
		// note: while tDB*Error is true, that means everything is good and no error..
		let isDigitalFunc = this.isDigitalFunc();
		let isAddressOK = !isDigitalFunc && tDBAddressError;
		isAddressOK ||= isDigitalFunc && tDBAddressErrorDigitalCoin;
		if (isAddressOK && tDBNameError && tDBAddress && tDBName) {
			this.setState({ addTDBBtnStatue: true });
		} else {
			this.setState({ addTDBBtnStatue: false });
		}
	}
	exchangeRateMoneyTest = (e, t) => {
		let value = e.target.value
			.replace(/[^\d.]/g, '')
			.replace(/^\./g, '')
			.replace(/\.{2,}/g, '.')
			.replace('.', '$#$')
			.replace(/\./g, '')
			.replace('$#$', '.')
			.replace(/^(\.*)(\d+)(\.?)(\d{0,2}).*$/g, '$2$3$4');
		let isDigitalFunc = this.isDigitalFunc();
		if (t == 'money') {
			if (isDigitalFunc) {
				this.setState({ withdrawalMoney: value }, () => this.changeBtnStatus(depositMoneyDecimal.test(value), true))
			} else { // isCryptoFunc
			this.setState({ withdrawalMoney: value }, () => {
				this.changeBtnStatus(depositMoneyDecimal.test(value));
				clearTimeout(this.usdtWithdrawInputTimer);
				this.usdtWithdrawInputTimer = setTimeout(() => {
					this.state.ctcMethod && this.getEquivalentCoinAmount();
				}, 300);
			});
		}
		}
	};
	changeTDBAddress(v) {
		if (v == -1) return;
		this.setState({ defaulttDBWalletId: v }, () => {
			this.changeBtnStatus(true);
		});
		const selectTDBName =
			this.state.tDBWalletList.length && this.state.tDBWalletList.find((item) => item.id === v).walletName;
		const selectTDBAddress =
			this.state.tDBWalletList.length && this.state.tDBWalletList.find((item) => item.id === v).walletAddress;
		this.setState({ selectTDBName, selectTDBAddress });
	}
	changeBtnStatus(bool, isDigital=false) {
		const {
			withdrawalMoney,
			minMoney,
			maxMoney,
			defaulttDBWalletId,
			selectTDBAddress,
			selectTDBName,
			ctcMethod,
			digitalcoinMethod,
			cryptoMemberType,
			CurrentQuota
		} = this.state;

		/**
		* 1st level boolean logic:
		* when Crypto interface, isDigital is false (from 2023)
		* when Digitalcoin interface, isDigital is true (from 2024)
		*/
		const bool5 = (isDigital || defaulttDBWalletId > 0) &&
				(isDigital || selectTDBAddress) &&
				(isDigital || selectTDBName) &&
				((isDigital&&digitalcoinMethod&&this.getSelectedDigitalCoinWallet()?.walletAddress) || (!isDigital&&ctcMethod));
		if (cryptoMemberType === 'Monitoring') {
			if (
				bool == true &&
				withdrawalMoney >= minMoney &&
				withdrawalMoney <= maxMoney &&
				withdrawalMoney <= CurrentQuota &&
				bool5
			) {
				this.setState({
					tDBSubmitbtnStatus: true,
					withdrawalMoney
				});
			} else {
				this.setState({ tDBSubmitbtnStatus: false });
			}
		} else {
			if (
				bool == true &&
				withdrawalMoney >= minMoney &&
				withdrawalMoney <= maxMoney &&
				bool5
			) {
				this.setState({
					tDBSubmitbtnStatus: true,
					withdrawalMoney
				});
			} else {
				this.setState({ tDBSubmitbtnStatus: false });
			}
		}
	}
	showdefaulttDBWallet() {
		let name = '',
			address = '',
			id = '';
		if (this.state.tDBWalletList.length) {
			this.state.tDBWalletList.find((item) => {
				if (item.isDefault == true) {
					name = item.walletName;
					address = item.walletAddress;
					id = item.id;
				}
			});
		}
		this.setState({
			selectTDBName: name,
			selectTDBAddress: address,
			defaulttDBWalletId: id
		});
	}
	goTransferPage() {
		global.showDialog({ key: 'wallet:{"type": "transfer"}' });
	}
	//泰达币钱包操作提示
	showInfoModal(value) {
		message.success(value);
		return;
		Modal.info({
			title: ``,
			centered: true,
			content: `${value}`,
			className: 'showInfoWalletModal'
		});
		setTimeout(() => {
			Modal.destroyAll();
		}, 2000);
	}

	handleCancelModal = () => {
		this.setState({ lessonModal: false });
	};

	setAttemptRemaining = (e) => {
		// 修改剩餘次數
		this.setState({
			checkAbleSmsOTP: { ...this.state.checkAbleSmsOTP, attempts: e }
		});
	};

	VerifyStatus = (PhoneParam, walletVisible, exceed, conf={}) => {
		// 控制驗證彈窗，phone驗證，錢包,超過次數
		let { digitalcoinMethod } = this.state;
		const isForDigitalCoin = conf && conf.isForDigitalCoin;
		const exec = (more={}) => {
		this.setState({...more, ...{
			phoneVisible: PhoneParam,
			[isForDigitalCoin ? 'visibleDigitalCoinWallet' : 'visibleExchangeRateWallet']: walletVisible,
			exceedVisible: exceed
		}}, ()=>{
            if (!isForDigitalCoin) {
            PhoneParam && this.sendPiwikUrl('withdrawal_crypto_phone_verification');
            walletVisible && this.sendPiwikUrl('withdrawal_crypto_add_wallet');
            }
		});
		}; // end of exec
		if (isForDigitalCoin && walletVisible) { // when open digitalWallet
			CheckDigitalCoinWallet(res => {
				if (res && Array.isArray(res.result)) {
					const resetModalUI = {tDBAddressError: false, tDBAddressErrorDigitalCoin: false}
					exec({...{aryDigitalCoin: res.result, tDBName:digitalcoinMethod}, ...resetModalUI})
				} else {
					message.error('添加代币钱包初始化失败');
				}
			});
		} else {
			exec();
		}
	};
	lBWithdrawalBtn(val) {
		if (val === 'goAway') {
			this.setState({ isShowLBWithdrawalModal: false });
		}
		if (val === 'carryOn') {
			this.setState({ isShowLBWithdrawalModal: false, lBWithdrawalFlag: true }, () => {
				this.props.form.validateFields((err, values) => {
					if (!err) {
						let postData = {};
						const { alreadyBindBanks, defaultBankCardId, defaultWithdrawMethod } = this.state;
						postData = {
							accountHolderName: alreadyBindBanks[defaultBankCardId].accountHolderName,
							accountNumber: alreadyBindBanks[defaultBankCardId].accountNumber,
							bankAccountId: alreadyBindBanks[defaultBankCardId].bankAccountID,
							amount: values.money,
							bankName: alreadyBindBanks[defaultBankCardId].bankName,
							branch: alreadyBindBanks[defaultBankCardId].branch,
							charges: 0,
							city: alreadyBindBanks[defaultBankCardId].city,
							domainName: ApiPort.LOCAL_HOST,
							isMobile: false,
							isSmallSet: false,
							language: 'zh-cn',
							paymentMethod: this.props.currentWithdrawKey,
							province: alreadyBindBanks[defaultBankCardId].province,
							shouldSaveBank: false,
							swiftCode: alreadyBindBanks[defaultBankCardId].SWIFTCode,
							transactionType: 'Withdrawal',
							method: 'LB',
							methodCode: 'DEFAULT'
						};
						// if (
						//     Array.isArray(this.state.suggestedAmounts) &&
						//     this.state.suggestedAmounts.length &&
						//     this.state.suggestedAmounts.every(
						//         (item) => item.amount !== values.money
						//     )
						// ) {
						//     this.getClosedPrefixAmount(postData);
						// } else {
						this.submitPay(postData);
						// }
					}
				});
			});
		}
	}
	showExchangeDialog = () => {
		const {
			currencyType,
			ctcMethod,
			ExchangeAmount1,
			ExchangeAmount2,
			TiersAmount1,
			TiersAmount2,
			ConvertedAmount,
			WithdrawableBalances,
			BalancesUpdatedAt,
			DepositedAmount,
			WithdrawAmount
		} = this.state;

		const exchangeConfirm = Modal.confirm({
			className: 'confirm-modal-of-public',
			icon: <div />,
			centered: true,
			title: '换算等值的加密货币',
			content: (
				<div className="Usdt-Exchange ">
					<div className="DepositMoeny ">
						<span>提款金额</span>
						<span>{this.state.withdrawalMoney} 元</span>
					</div>
					<ul className="DepositMoenyList ">
						<li>
							<div>您的加密货币存款金额一共是 {DepositedAmount} 元</div>
							<small>更新时间：{BalancesUpdatedAt}</small>
						</li>
						<li>
							<div>您的加密货币提款金额一共是{WithdrawAmount}元</div>
							<small>更新时间：{BalancesUpdatedAt}</small>
						</li>
						<li>
							<div>您的加密货币余额为{WithdrawableBalances}元</div>
							<small>更新时间：{BalancesUpdatedAt}</small>
						</li>
					</ul>
					<ul className="ChangeList">
						<li>
							您的加密货币余额将按汇率等级1(免手续费)兑换:
							<br />
							<span className="blue">
								{TiersAmount1} {currencyType} = {ExchangeAmount1} {ctcMethod}
							</span>
						</li>
						<li>
							其余提款的金额将按照汇率等级2(征收手续费)兑换:
							<br />
							<span className="blue">
								{TiersAmount2} {currencyType} = {ExchangeAmount2} {ctcMethod}
							</span>
						</li>
						<li>
							您该笔提款的等值加密货币为
							<br />
							<span className="blue">
								{ConvertedAmount.toFixed(4)} {ctcMethod}
							</span>
						</li>
					</ul>
					<div className="TextLightYellow">贴心提醒: 汇率仅供参考，交易将以实时汇率计算</div>
				</div>
			),
			okText: '是的，我知道了',
			cancelText: '联系在线客服',
			cancelButtonProps: {
				onClick: () => {
					exchangeConfirm.destroy();
					global.PopUpLiveChat();
				}
			}
		});
	};
	getTip = conf => {
		if (conf && conf.is1vs1) {
			return (
				<p className="TextLightGrey P10 ">
					参考汇率：1 {this.mainCurrency} = 1 {conf && conf.theMethod && DigitalcoinUtil.getCoinNameByCoinType(conf.theMethod)}
				</p>
			);
		}
		const {
			withdrawalMoney,
			WithdrawableBalances,
			ExchangeRate1,
			ExchangeRate2,
			currencyType,
			ctcMethod
		} = this.state;
		if (ExchangeRate2 == 0) {
			return (
				<p className="TextLightGrey P10 ">
					<p>参考汇率：</p>1 {currencyType} = {ExchangeRate1} {ctcMethod} <br />
					<span>此汇率仅供参考，交易将以实时汇率进行。</span>
				</p>
			);
		}
		if (WithdrawableBalances == 0) {
			return (
				<p className="TextLightGrey P10">
					<p>参考汇率：</p>1 {currencyType} = {ExchangeRate2} {ctcMethod} <br />
					<span>此汇率仅供参考，交易将以实时汇率进行。</span>
				</p>
			);
		}
		if (parseInt(withdrawalMoney) > WithdrawableBalances) {
			return (
				<p className="TextLightGrey P10">
					<p>参考汇率：</p>
					级别 1（免手续费）: 1 {currencyType} = {ExchangeRate1} {ctcMethod} <br />
					级别 2（征收手续费）: 1 {currencyType} = {ExchangeRate2} {ctcMethod}
					<br />
					汇率仅供参考，交易将以实时汇率计算
					<br />
					<Button type="link" className="inline" onClick={this.showExchangeDialog}>
						点击此处了解如何换算等值的加密货币
					</Button>
				</p>
			);
		} else {
			return (
				<p className="TextLightGrey P10">
					<p>参考汇率：</p>1 {currencyType} = {ExchangeRate1} {ctcMethod} <br />
					<span>此汇率仅供参考，交易将以实时汇率进行。</span>
				</p>
			);
		}
	};
	changeLBType = ({ target: { value } }) => {
		this.props.setCurrentWithdrawType(value);
		this.GETWithdrawalAnyoneDetails('LB', value);
		this.props.setCurrentWithdrawMethod('LB', value);
		this.setState({
			withdrawalMoney: '',
			lbWithdrawalDisabledStatus: true
		});
	};
	/**
     * 已有部分提现方式再获取更多提现方式的验证
     */
	openBankAccountVerif = () => {
		this.setLoading(true);
		get(ApiPort.GetOTPAttempts + '&serviceAction=BankCardValidation&channelType=SMS')
			.then((res) => {
				if (res) {
					let attempt = getAttemptVal(res);
					/* see doc: /wiki/x/Ji6jAw
					if (res.submitOTPAttempts < 1 || res.requestOTPAttempts < 1) {
					*/
					if (!attempt) {
						this.setLoading(false);
						this.exceedTryNumber();
					} else {
						get(ApiPort.GetBankcardVerificationAttempts)
							.then((res) => {
								this.setLoading(false);
								if (res.isSuccess) {
									if (res.bankcardVerificationAttempts < 1) {
										this.exceedTryNumber();
									} else {
										this.setState(
											{
												step: 2,
												submitOTPAttempts: res.bankcardVerificationAttempts
											},
											() => {
												Modal.confirm({
													title: '',
													icon: null,
													centered: true,
													width: 400,
													okText: '立即验证',
													cancelText: '稍后验证',
													content: (
														<div>
															<div>
																<img src={'/cn/img/icons/icon-warn.svg'} />
															</div>
															<div
																className="content"
																style={{
																	textAlign: 'center',
																	marginTop: 20
																}}
															>
																<p> , 请完成您的个人信息验证, 以便开通更多的充值和提现方式哦。</p>
															</div>
														</div>
													),
													onOk: () => {
														this.setState({
															isOpenRealyName: true
														});
													}
												});
											}
										);
									}
								}
							})
							.catch((err) => {
								this.setLoading(false);
								console.log(err);
							});
					}
				}
			})
			.catch((err) => {
				this.setLoading(false);
				console.log(err);
			});
		Pushgtagdata('Verification​', 'Click', 'IWMM_PII_WithdrawalPage​​');
	};
	closeAllModal = () => {
		Modal.destroyAll();
		this.props.onCancel();
		this.setState({ isOpenRealyName: false });
	};
	exceedTryNumber = (callback) => {
		const call = () => {
			if (typeof callback === 'function' && callback()) {
				this.closeAllModal();
			} else {
				this.setState({
					step: 2,
					banksVerificationManual: true
				});
			}
		};
		const callCancel = () => {
			exceedTryNumM.destroy();
		};
		const exceedTryNumM = Modal.info({
			title: '信息验证',
			width: 340,
			centered: true,
			okText: '手动绑定',
			content: (
				<div className="inline-link-btn">
					<div>
						<img src={'/cn/img/icons/icon-warn.svg'} />
					</div>
					<div className="content" style={{ marginTop: 20 }}>
						<h3 style={{ fontSize: '18px', fontWeight: '900' }}> 您已超过 5 次尝试</h3>
						<p style={{ textAlign: 'left' }}>
							可以尝试手动绑定进行验证，或联系我们的
							<Button type="link" onClick={global.PopUpLiveChat}>
								在线客服
							</Button>
							。
						</p>
					</div>
				</div>
			),
			onCancel: callCancel,
			onOk: call
		});
	};
	/**
     * @param {Object} postData 充值所需的参数
     * 获取第二层的建议金额
     * 当会员没有选取第一层的建议金额，输入的金额也和第一层建议金额不一样时，调用这个方法
     * 此api会返回一个最靠近会员输入的金额的数字。api返回的这个数字只会小于会员输入的金额
     */
	getClosedPrefixAmount = (postData) => {
		if (postData && postData.amount) {
			this.setLoading(true);
			get(
				ApiPort.GetPrefixAmount +
					`&method=LB&TransactionType=Withdrawal&Amount=${postData.amount}&MethodCode=DEFAULT`
			)
				.then((res) => {
					this.setLoading(false);
					if (res && res.result.isExist && res.result.prefixAmount) {
						const confirmPopup = Modal.confirm({
							className: 'confirm-modal-of-public',
							icon: <div />,
							centered: true,
							width: 400,
							okText: '好的',
							cancelText: '取消',
							content: (
								<div>
									<div
										className="content"
										style={{
											textAlign: 'center',
											marginTop: 20
										}}
									>
										<p> 快速提现 {res.result.prefixAmount} 元已开启，即刻体验推荐金额吗?</p>
									</div>
								</div>
							),
							onOk: () => {
								postData.amount = res.result.prefixAmount;
								this.submitPay(postData);
								confirmPopup.destroy();
							},
							cancelButtonProps: {
								ghost: true,
								type: 'primary',
								onClick: () => {
									this.submitPay(postData);
									confirmPopup.destroy();
								}
							}
						});
					} else {
						this.submitPay(postData);
					}
				})
				.catch((error) => {
					console.log('Withdrawal ~ error', error);
					this.setLoading(false);
					this.submitPay(postData);
				});
		}
	};
	/*
     * 處理一鍵轉帳
     */
	getE2BBValue() {
		return window.E2GetBlackbox
			? window.E2GetBlackbox().blackbox == '' || window.E2GetBlackbox().blackbox == undefined
				? ''
				: window.E2GetBlackbox().blackbox
			: '';
	}
	handleTransfer(TotalBal) {
		this.setLoading(true);
		let DATA = {
			fromAccount: 'ALL',
			toAccount: 'MAIN',
			amount: TotalBal,
			blackBoxValue: this.getE2BBValue(),
		};

		TransferSubmit(DATA, (res) => {
			this.setLoading(false);
			if (res.isSuccess && res.result) {
				if (res.result.status == 1) {
					this.AllBalance();
					console.log('transfer success');
					message.success('转账成功');
				}
			} else {
				message.error('转账失败');
				console.log('transfer fail');
			}
		});
	}

	/**
     *
     * 拿預約時間的API
     */
	GetPayoutDurations() {
		let paymentMethod = 'LB';
		let hash = {hostName: ApiPort.LOCAL_HOST, paymentMethod,
					methodCode:this._getMethodValueFromTypeValue(this.props.currentWithdrawType)};
		get(ApiPort.GETWithdrawalDetailsAPI2.replace(/{.*?}/g, m=>hash[m.replace(/[{}]/g,'')])).then((res) => {
			if (!res) { return; }
			if (res && res.IS_FEAT_MAINTENANCE) { return; }
			const durations = res.result?.dynamicObject?.payoutDurations;
			this.setState({
				AllpayoutDurations: durations,
				payoutDurationsDisabledStatus: true
			});

			if (this.state.AllpayoutDurations.length === 0) {
				this.setState({
					maxPayoutDurationInMins: '',
					payoutDurationRebatePercent: '',
					payoutDurationsDisabledStatus: false
				});
			}

			if (this.state.AllpayoutDurations.length === 1) {
				this.setState({
					maxPayoutDurationInMins: durations?.[0].maxDurationInMins,
					payoutDurationRebatePercent: durations?.[0].payoutDurationRebatePercent,
					payoutDurationsDisabledStatus: false
				});
			}
		});
	}

	timeChange(minDuration, maxDuration, payoutDurationRebate) {
		console.log(minDuration, maxDuration, payoutDurationRebate);
		if (minDuration == 0 && maxDuration == 0) {
			return (
				<div style={{ width: '165px' }}>
					<span>立即提款 - </span>
					<span className="blue">加送{payoutDurationRebate}%</span>
				</div>
			);
		} else if (minDuration == 0 && maxDuration < 60) {
			return (
				<div style={{ width: '165px' }}>
					{maxDuration}
					<span>分钟內提款 - </span>
					<span className="blue">加送{payoutDurationRebate}%</span>
				</div>
			);
		} else if (maxDuration % 60 == 0) {
			return (
				<div style={{ width: '165px' }}>
					{minDuration}-{parseInt(maxDuration / 60)}
					<span>小时内提款 - </span>
					<span className="blue">加送{payoutDurationRebate}%</span>
				</div>
			);
		} else {
			return (
				<div style={{ width: '165px' }}>
					{minDuration}-{parseInt(maxDuration / 60)}
					<span>小时{parseInt(maxDuration % 60)}分钟内提款 - </span>
					<span className="blue">加送{payoutDurationRebate}%</span>
				</div>
			);
		}
	}

	BlueData(data) {
		return <span className="blue">加送{data}%</span>;
	}

	handleTime(time) {
		if (time == 0) {
			return `您的提现将于1小时内完成， 请您耐心等待！`;
		} else if (time / 60 >= 1) {
			if (time % 60 == 0) {
				return `您的提现将于${time / 60}小时内完成， 请您耐心等待！`;
			} else {
				return `您的提现将于${parseInt(time / 60)}小时${time % 60}分钟内完成， 请您耐心等待！`;
			}
		} else {
			return `您的提现将于${time % 60}分钟内完成， 请您耐心等待！`;
		}
	}

	getSelectedDigitalCoinWallet() {
		let { aryDigitalCoin, digitalcoinMethod } = this.state;
		if (!this.isDigitalFunc() || !digitalcoinMethod || !aryDigitalCoin || !aryDigitalCoin.length) { return {}; }
		return aryDigitalCoin.find(dc=>dc.cryptocurrency==digitalcoinMethod) || {};
	}
	render() {
		const {
			withdrawMethodsList,
			defaultWithdrawMethod,
			alreadyBindBanks,
			defaultBankCardId,
			visibleDigitalCoinWallet,
			visibleExchangeRateWallet,
			tDBNameError,
			tDBAddressError,
			tDBAddressErrorDigitalCoin,
			tDBAddressError2,
			tDBAddress,
			tDBName,
			minMoney,
			maxMoney,
			dayMoney,
			withdrawalMoney,
			tDBisSuccess,
			addTDBBtnStatue,
			aryDigitalCoin,
			tDBWalletList,
			tDBSubmitbtnStatus,
			defaulttDBWalletId,
			checkAbleSmsOTP,
			phoneVisible,
			memberInfo,
			exceedVisible,
			isLoading,
			isShowLBWithdrawalTip,
			isShowLBWithdrawalModal,
			isLBDescriptionCode,
			ConvertedAmount,
			lbWithdrawalDisabledStatus,
			suggestedAmounts,
			lbMethodsResult,
			rebateAmount,
			payoutMode,
			isShowBankCardVerif,
			banksVerificationManual,
			AllpayoutDurations,
			maxPayoutDurationInMins,
			payoutDurationRebatePercent,
			payoutDurationsDisabledStatus,
			transactionId,
			defaultAccount,
			ToAccountVerification,
			cryptoMemberType,
			CurrentQuota,
			IsStaticQuota
		} = this.state;
		let {
			ctcWithdrawType,
			ctcMethod,
			digitalcoinWithdrawType,
			digitalcoinMethod,
		} = this.state;
		const isCryptoFunc = this.isCryptoFunc();
		const isDigitalFunc = this.isDigitalFunc();
		if (isDigitalFunc) {
			ctcWithdrawType = digitalcoinWithdrawType;
			ctcMethod = digitalcoinMethod;
		}
		const theDigitalWalletAddress = this.getSelectedDigitalCoinWallet();
		const { getFieldDecorator } = this.props.form;
		const { currentWithdrawType } = this.props;
		const limitedDisplay = (() => {
			return isCryptoFunc ? '' : DigitalcoinUtil.getHardCodeNameByCoinType(digitalcoinMethod);
		})();
		console.log('>>>>>>>>', memberInfo);
		return (
			<React.Fragment>
				{/* {this.props.currentWithdrawKey != "CCW" && (
                    <a
                        className="deposit-help-link"
                        onClick={() => {
                            Router.push(
                                "/cn/Help?type=Sub3&key=" +
                                    CMSOBJ[HostConfig.CMS_ID][29]
                            );
                            Pushgtagdata("Tutorial_withdrawal_wallet");
                        }}
                    >
                        查看提现教学
                    </a>
                )}
                {this.props.currentWithdrawKey == "CCW" && (
                    <a
                        className="deposit-help-link"
                        onClick={() => {
                            this.setState({ lessonModal: true });
                        }}
                    >
                        查看提现教学
                    </a>
                )} */}
                <a
                    className="deposit-help-link"
                    onClick={() => {
                        if (isDigitalFunc) {
                        this.sendPiwikEvent('Withdrawal', `View Tutorial`, `Withdrawal_DigitalCoin_C_Tutorial`);
                        this.setState({digitalCoinLessonModal:true})
                        } else {
                        this.sendPiwikEvent('Withdrawal', `View Tutorial`, `Withdrawal_Crypto_C_Tutorial`);
                        this.setState({withdrawLessonModal:true})
                        }
                    }}
                    style={{display:isCryptoFunc||isDigitalFunc ? '' : 'none', color:isCryptoFunc||isDigitalFunc ? '#00A6FF' : ''}}
                >
                    查看提款教程
                </a>

				{!this.state.isSuccess ? cryptoMemberType === 'Locked' ? null : (
					<div>
						<div className="MainBlance">
							<div className="item-blance" flex="1">
								<label className="item-label">总余额</label>

								<b>￥{this.state.TotalBal || '0'}</b>
							</div>

							<div className="item-blance">
								<label className="item-label">
									主账户
									<img
										className="Transfericon"
										src="/cn/img/wallet/transfericon.svg"
										onClick={() => {
											this.handleTransfer(TotalBal);
											//Pushgtagdata(`Transfer`, 'Submit', `QuickTransfer_WithdrawPage`);
											this.sendPiwikEvent('Withdrawal', 'One Click Transfer', 'Withdrawal_C_OneClickTransfer')
										}}
									/>
								</label>

								<b>￥{this.state.MAINBal || '0'}</b>
							</div>

							<div
								className="item-blance"
								// justifyContent="space-between"
								// alignItems="center"
								onClick={() => {
									this.setState({
										showAll: !this.state.showAll
									});
									this.sendPiwikEvent('Withdrawal', 'Expand Balance', 'Withdrawal_C_Balance');
								}}
							>
								<label className="item-label">
									其他钱包
									<img className="Downicon" src="/cn/img/wallet/dropdown.svg" />
								</label>
								<b>￥{this.state.otherWalletTotal.toFixed(2)}</b>
							</div>
						</div>
						{/* <div className="card-balance-wrap" style={{ display: this.state.showAll ? 'block' : 'none' }}>
							{this.state.balanceList && this.state.balanceList.length ? (
								this.state.balanceList.map((val, index) => {
									if (val.category === 'Main' || val.category === 'TotalBal') return null;
									return (
										<div className="balance-box" key={'walletTransfer' + index} onClick={() => {}}>
											<div>
												<span>{val.localizedName}</span>
												{val.name === 'SB' ? (
													<Popover
														overlayStyle={{ zIndex: 1000 }}
														align={{ offset: [ -4, 0 ] }}
														placement="bottomLeft"
														overlayClassName="popover-dark"
														content={<div>包含 醉心体育, 沙巴体育, BTI 体育, IM 体育和电竞</div>}
														title=""
														trigger="hover"
													>
														<span className="header-popover-inner-tip pointer">
															<Icon type="question-circle" />
														</span>
													</Popover>
												) : null}
											</div>
											<div>{val.state === 'UnderMaintenance' ? '维护中' : '￥' + val.balance}</div>
											<div className="btn" />
										</div>
									);
								})
							) : null}
						</div> */}
						<BlanceModal
							blanceModalVisible={this.state.showAll}
							closable={() => {
								this.setState({
									showAll: false
								});
							}}
							balanceList={this.state.balanceList}
						/>
					</div>
				) : null}

				<div className="div-cannot-use" style={{display: this.state.isCannotUseVisible ? '' : 'none'}}>
					<div className="div-cannot-use-inner">
						<img src="/cn/img/icons/lock.svg" width="64" height="64" alt="Lock icon" />
						抱歉，您无法使用{this.cannotUseText1Map[this.props.currentWithdrawKey||'UNDEF'] || '--'}提款，<br />如有任何问题请联系在线客服。
					</div>
				</div>
				<Form
					className="form-wrap large"
					{...formItemLayout}
					onSubmit={this.handleSubmit}
					style={{
						display: !this.state.isSuccess ? 'block' : 'none'
					}}
				>
					<div
						className="modal-prompt-info"
						style={{
							display: isShowBankCardVerif ? 'block' : 'none',
							color: '#2962FF',
							textAlign: 'center',
							cursor: 'pointer'
						}}
						onClick={() => this.openBankAccountVerif()}
					>
						<span className="spanText">开启更多充值和提现方式</span>
						<p className="pText">点击上方按钮完成验证，我们为您承担网银转账 5% 手续费</p>
					</div>
					{/* {this.props.currentWithdrawKey != "CCW" && (
                        <div className="modal-prompt-info">
                            温馨提示：提现需要先将资金转入主账户。
                        </div>
                    )} */}

					{!this.state.isCannotUseVisible && this.props.currentWithdrawKey === 'APW' && (
						<div>
							<Item label="手机号码">
								<Input
									size="large"
									className="tlc-input-disabled"
									disabled={true}
									value={this.state.phone}
								/>
							</Item>
							<Item label="提款金额">
								{getFieldDecorator('money', {
									rules: [
										{
											required: true,
											message: '请填写提款金额！'
										},
										{
											validator: (rule, value, callback) => {
												if (!depositMoneyInt.test(value)) {
													callback('金额格式错误');
												}
												if (value && value < this.withdrawalLimit.min) {
													callback('最低提款金额：' + this.withdrawalLimit.min);
												}
												if (value && value > this.withdrawalLimit.max) {
													callback('最高提款金额：' + this.withdrawalLimit.max);
												}
												callback();
											}
										}
									]
								})(
									<Input
										size="large"
										autoComplete="off"
										placeholder={`单笔提款 最低：${this.withdrawalLimit.min}元起，最高：${this.withdrawalLimit
											.max}元。 `}
									/>
								)}
							</Item>
							{/* 仅作为增加间距盒子 */}
							<div className="line-distance" />
							<Item {...tailFormItemLayout}>
								<div className="btn-wrap">
									<Button size="large" type="primary" htmlType="submit" block>
										提交
									</Button>
								</div>
							</Item>
						</div>
					)}
					{!this.state.isCannotUseVisible && this.props.currentWithdrawKey === 'LB' && (
						<div className="currentWithdraw-lb">
							{suggestedAmounts && suggestedAmounts.length ? (
								<div>
									{/* <div className="modal-prompt-info">
                                        使用快捷金额提款，收到提款后，前往【交易记录】页面点击【确认到账】可享有最高返利0.4%
                                    </div> */}
									{/* <Item label="快捷提款">
                                        <div className="suggested-amount-wrap">
                                            <ul>
                                                {suggestedAmounts.map(
                                                    (value, index) => {
                                                        return (
                                                            <li
                                                                className={`${
                                                                    withdrawalMoney ==
                                                                    value.amount
                                                                }${
                                                                    !value.isActive
                                                                        ? " disabled"
                                                                        : ""
                                                                }`}
                                                                onClick={() => {
                                                                    if (
                                                                        !value.isActive
                                                                    ) {
                                                                        return false;
                                                                    }
                                                                    this.setState(
                                                                        {
                                                                            withdrawalMoney:
                                                                                value.amount,
                                                                            lbWithdrawalDisabledStatus: false,
                                                                        }
                                                                    );
                                                                    this.props.form.setFieldsValue(
                                                                        {
                                                                            money: value.amount,
                                                                        }
                                                                    );
                                                                }}
                                                                key={index}
                                                            >
                                                                {value.amount}
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        </div>
                                    </Item> */}
								</div>
							) : null}
							<Item label="提款金额">
								{getFieldDecorator('money', {
									initialValue: withdrawalMoney,
									rules: [
										{
											validator: (rule, value, callback) => {
												this.setState({
													showLBWithdrawalInfo:
														value && value >= this.withdrawalLimit.min && value < 5000
												});
												this.setState({
													showLBWithdrawalMaxInfo:
														value && value <= this.withdrawalLimit.max && value > 100000
												});
												if (!value) {
													this.setState({
														lbWithdrawalDisabledStatus: true
													});
													callback('请填写提款金额！');
													return;
												}
												if (!depositMoneyInt.test(value)) {
													this.setState({
														lbWithdrawalDisabledStatus: true
													});
													callback('金额格式错误');
													return;
												}
												if (value && value < this.withdrawalLimit.min) {
													this.setState({
														lbWithdrawalDisabledStatus: true
													});
													callback('最低提款金额为' + formatAmount(this.withdrawalLimit.min) + '元');
													return;
												}
												if (value && value > this.withdrawalLimit.max) {
													this.setState({
														lbWithdrawalDisabledStatus: true
													});
													callback('最高提款金额为' + formatAmount(this.withdrawalLimit.max) + '元');
													return;
												}
												this.setState({
													lbWithdrawalDisabledStatus: false,
													withdrawalMoney: value
												});

												callback();
											}
										}
									]
								})(
									<Input
										size="large"
										autoComplete="off"
										placeholder={`单笔提款 最低：${this.withdrawalLimit.min}元起，最高：${this.withdrawalLimit
											.max}元。 `}
									/>
								)}
							</Item>
							<LBBankAccount
								goBankAccount={this.goBankAccount}
								changeBankCard={this.changeBankCard}
								defaultBankCardId={defaultBankCardId}
								alreadyBindBanks={alreadyBindBanks}
								isBankUpgradingError={this.state.isBankUpgradingError}
								isLBDescriptionCode={isLBDescriptionCode}
								isShowLBWithdrawalTip={isShowLBWithdrawalTip}
								currentWithdrawType={currentWithdrawType}
							/>
							<Checkbox
								icon={<BsCheckSquareFill color="#00A6FF" size={20} />}
								onChange={(value) => {
									this.setState({
										defaultAccount: value
									});
								}}
							>
								设定为首选银行账户
							</Checkbox>
							:
							{/* <div className="modal-prompt-info">
                                {this.state.showLBWithdrawalInfo ? <span className="error-color">*注意：提现处理时间可能长达 3 小时，为了加快交易速度，建议您单笔提款金额大于 5,000 元。</span> : null}
                                {this.state.showLBWithdrawalMaxInfo ? <span className="error-color">*注意：提现处理时间可能长达 3 小时，为了加快交易速度，建议您单笔提款金额小于 100,000 元。</span> : null}
                                <div>单笔提现最低￥ {formatAmount(minMoney)}， 最高￥ {formatAmount(maxMoney)} <br />单日提款金额为￥ {formatAmount(dayMoney)}</div>
                            </div> */}
							<Item>
								{AllpayoutDurations.length === 0 ? (
									<div />
								) : AllpayoutDurations.length === 1 ? (
									<div>
										<Item label="预约提款时间">
											<div className="radioCon">
												{AllpayoutDurations.map((item, index) => (
													<React.Fragment>
														{item.maxDurationInMins ===
														0 ? item.payoutDurationRebatePercent == 0 ? (
															<div className="radio__btn">
																<input
																	type="radio"
																	id={item.sortOrder}
																	name="appointment"
																	value={item.sortOrder}
																	checked
																	// onChange={onChange}
																/>
																<label for={item.sortOrder}> {'立即提款'}</label>
															</div>
														) : (
															<div className="radio__btn">
																<input
																	type="radio"
																	id={item.sortOrder}
																	name="appointment"
																	value={item.sortOrder}
																	checked
																	// onChange={onChange}
																/>
																<label for={item.sortOrder}>
																	立即提款 -
																	{this.BlueData(item.payoutDurationRebatePercent)}
																</label>
															</div>
														) : (
															<div className="radio__btn">
																<input
																	type="radio"
																	id={item.sortOrder}
																	name="appointment"
																	value={item.sortOrder}
																	checked
																	// onChange={onChange}
																/>
																<label for={item.sortOrder}>
																	{' '}
																	{this.timeChange(
																		item.minDurationInMins,
																		item.maxDurationInMins,
																		item.payoutDurationRebatePercent
																	)}
																</label>
															</div>
														)}
													</React.Fragment>
												))}

												<br />
											</div>
										</Item>
									</div>
								) : (
									<React.Fragment>
										<Item label="预约提款时间">
											<div className="radioCon">
												{AllpayoutDurations.map((item, index) => (
													<React.Fragment>
														{item.maxDurationInMins ===
														0 ? item.payoutDurationRebatePercent == 0 ? (
															<div className="radio__btn">
																<input
																	type="radio"
																	id={item.sortOrder}
																	name="appointment"
																	value={item.sortOrder}
																	onChange={(e) => {
																		this.setState({
																			Appointment: item.sortOrder,
																			maxPayoutDurationInMins:
																				item.maxDurationInMins,
																			payoutDurationRebatePercent: 0,
																			payoutDurationsDisabledStatus: false
																		});
																	}}
																/>
																<label for={item.sortOrder}> {'立即提款'}</label>
															</div>
														) : (
															<div className="radio__btn">
																<input
																	type="radio"
																	id={item.sortOrder}
																	name="appointment"
																	value={item.sortOrder}
																	onChange={(e) => {
																		this.setState({
																			Appointment: item.sortOrder,
																			maxPayoutDurationInMins:
																				item.maxDurationInMins,
																			payoutDurationRebatePercent:
																				item.payoutDurationRebatePercent,
																			payoutDurationsDisabledStatus: false
																		});
																	}}
																/>
																<label for={item.sortOrder}>
																	立即提款 -
																	{this.BlueData(item.payoutDurationRebatePercent)}
																</label>
															</div>
														) : (
															<div className="radio__btn">
																<input
																	type="radio"
																	id={item.sortOrder}
																	name="appointment"
																	value={item.sortOrder}
																	onChange={(e) => {
																		this.setState({
																			Appointment: item.sortOrder,
																			maxPayoutDurationInMins:
																				item.maxDurationInMins,
																			payoutDurationRebatePercent:
																				item.payoutDurationRebatePercent,
																			payoutDurationsDisabledStatus: false
																		});
																	}}
																/>
																<label for={item.sortOrder}>
																	{' '}
																	{this.timeChange(
																		item.minDurationInMins,
																		item.maxDurationInMins,
																		item.payoutDurationRebatePercent
																	)}
																</label>
															</div>
														)}
													</React.Fragment>
												))}
											</div>
										</Item>
									</React.Fragment>
								)}
							</Item>
							{/* 仅作为增加间距盒子 */}
							<Item {...tailFormItemLayout}>
								<div className="btn-wrap">
									<Button
										size="large"
										type="primary"
										htmlType="submit"
										disabled={
											this.state.isBankUpgradingError ||
											lbWithdrawalDisabledStatus == true || payoutDurationsDisabledStatus == true
										}
										block
									>
										提交
									</Button>
								</div>
							</Item>
							{/* <div style={{ padding: '12px', marginTop: '25px' }}>
								乐天使温馨提醒：<br />收到提现后，请前往【交易记录】页面点击 【确认到账】。
							</div> */}
						</div>
					)}
					{!this.state.isCannotUseVisible && this.isCryptoAlikeUI() &&
						!tDBisSuccess &&
						(cryptoMemberType !== 'Locked' ? (
							<div className="currentWithdraw-ccw ctc-wrapper">
								{/* <div className="modal-prompt-info">温馨提示：请提供正确的钱包地址，以便按时进行交易。 目前仅支持使用 USDT-ERC20 提款。提现需要先将资金转入主账户。<span className='goPage' onClick={this.goTransferPage}>前往转账</span></div> */}
								{/* <div className="modal-prompt-info">温馨提示：请提供所选泰达币的正确钱包地址，以便按时进行交易。</div> */}
								{Array.isArray(ctcWithdrawType) && ctcWithdrawType.length ? (
									<div className="ant-row ant-form-item">
										<div className="ant-col ant-form-item-label">
											<label className="" title="">
												{isCryptoFunc ? '选择加密货币' : '选择代币钱包'}
											</label>
										</div>
										<div className="ant-col ant-form-item-control-wrapper">
											{isDigitalFunc ? this.DigitalCoinTrait.renderSelect(ctcWithdrawType, ctcMethod) : ctcWithdrawType.map((item) => {
												return (
													<div
														key={item}
														className={`ctc-pay-method-item ${item}${ctcMethod === item
															? ' curr'
															: ''}`}
														onClick={() => {
															this.changeErcTrc(item, isCryptoFunc);
														}}
													>
														<i className={`tlc-sprite ${item}`} />
														<p>
															泰达币
															{item.substring(4)} (
															{item})
														</p>
													</div>
												);
											})}
										</div>
									</div>
								) : null}
								<Item
									className={cryptoMemberType === 'Monitoring' && 'ccw-withdrawal-amount-label'}
									label={
										cryptoMemberType === 'Monitoring' ? (
											<div>
												<span>提款金额</span>
                                                <span>剩余可提款额度 ¥ {CurrentQuota?.toFixed(2)}</span>
											</div>
										) : (
											'提款金额'
										)
									}
								>
									{cryptoMemberType === 'Monitoring' && CurrentQuota === 0 && IsStaticQuota ? (
										<div className="ccw-withdrawal-hint" style={{color:'#808080'}}>
											抱歉，您的{isCryptoFunc ? '泰达币' : ' '+limitedDisplay+' '}提款已达上限额度，请使用其他渠道或联系
											<span
												style={{ color: '#00a5fd', cursor: 'pointer' }}
												onClick={() => global.PopUpLiveChat()}
											>
												在线客服
											</span>
											。
										</div>
									) : cryptoMemberType === 'Monitoring' && CurrentQuota === 0 && !IsStaticQuota ? (
										<div className="ccw-withdrawal-hint">抱歉，{isCryptoFunc ? '泰达币' : limitedDisplay+' '}提款已达上限，请进行存款，以增加提现额度。</div>
									) : (
										<Input
											className="withdrawal-money-input"
											size="large"
											autoComplete="off"
											placeholder={`单笔提款 最低：${minMoney}元起，最高：${maxMoney}元`}
											onChange={(e) => this.exchangeRateMoneyTest(e, 'money')}
											value={withdrawalMoney}
										/>
										/* {withdrawalMoney > dayMoney && <p className="errorTip">单日提款金额为 {formatAmount(maxMoney)} 或以下的金额</p>} */
									)}
								</Item>
								{withdrawalMoney &&
									(cryptoMemberType === 'Monitoring' ? (
										<div style={this._getInlineCSSWithdrawalMoneyInputWithError()}>
											{withdrawalMoney > CurrentQuota ? (
												<div className="TextLightRed">提款金额超过剩余额度{this._getCSSStyleWithdrawalMoneyInputWithError()}</div>
											) : withdrawalMoney < minMoney ? (
												<div className="TextLightRed">
													最低提款金额 {formatAmount(minMoney || 0)} 元{this._getCSSStyleWithdrawalMoneyInputWithError()}
												</div>
											) : withdrawalMoney > maxMoney ? (
												<div className="TextLightRed">
													最高提款金额 {formatAmount(maxMoney || 0)} 元{this._getCSSStyleWithdrawalMoneyInputWithError()}
												</div>
											) : null}
										</div>
									) : (
										<div style={this._getInlineCSSWithdrawalMoneyInputWithError()}>
											{withdrawalMoney < minMoney && (
												<div className="TextLightRed">
													最低提款金额 {formatAmount(minMoney || 0)} 元{this._getCSSStyleWithdrawalMoneyInputWithError()}
												</div>
											)}
											{withdrawalMoney > maxMoney && (
												<div className="TextLightRed">
													最高提款金额 {formatAmount(maxMoney || 0)} 元{this._getCSSStyleWithdrawalMoneyInputWithError()}
												</div>
											)}
										</div>
									))}
								{/* <div className="modal-prompt-info">
                                    单笔提现最低￥ {formatAmount(minMoney)} 最高￥ {formatAmount(maxMoney)} <br />单日提款金额为￥{' '}
                                    {formatAmount(dayMoney)}{' '}
                                </div> */}
								{ctcMethod ? (
									<React.Fragment>
										<div className="modal-prompt-others">
											<p>{isCryptoFunc ? '虚拟币等值数量' : '等值数量'}</p>
											<div className="modal-prompt-label">
												{isCryptoFunc && ConvertedAmount ? ConvertedAmount.toFixed(4) + ' ' + ctcMethod : ''}
												{isDigitalFunc ? (withdrawalMoney ? withdrawalMoney : '0')+' '+DigitalcoinUtil.getCoinNameByCoinType(digitalcoinMethod) : ''}
											</div>
											</div>
										{this.getTip(isDigitalFunc ? {is1vs1:true, theMethod: ctcMethod} : undefined)}
										<Spin spinning={isLoading}>
											<Item label={isCryptoFunc ? "钱包地址" : '代币钱包地址'} className={isDigitalFunc ? 'ant-form-item-notrequired-label' : ''}>
												{isCryptoFunc && tDBWalletList && tDBWalletList.length ? (
													<div id="tabSelect" className="wrapAddWithdrawalWallet">
														<Select
															size="large"
															value={defaulttDBWalletId}
															dropdownClassName="selectTDBWallet"
															onChange={this.changeTDBAddress}
															getPopupContainer={() =>
																document.getElementById('tabSelect')}
															// 防止下拉框在滑动滚动条的时候不能同步
														>
															{tDBWalletList.map((item, index) => {
																return (
																	<Option key={index} value={item.id}>
																		<span>{item.walletName}</span>
																		<br />
																		<span>{item.walletAddress}</span>
																		{item.isDefault && <Icon type="check" />}
																	</Option>
																);
															})}
															{tDBWalletList.length < 3 && (
																<Option
																	value="-1"
																	className="selectTDBWallet-addBtn blue"
																	onClick={this.judgeOTPVerification}
																>
																	添加 {ctcMethod} 钱包地址
																</Option>
															)}
														</Select>
													</div>
												) : (theDigitalWalletAddress?.walletAddress ? null :
													<div
														className="add-ccw-withdrawMethod-btn blue"
														onClick={this.judgeOTPVerification}
													>
														<span style={{display: isCryptoFunc?'':'none'}}>添加 {ctcMethod} 钱包地址</span>
														<span style={{display: isDigitalFunc?'':'none'}}>添加代币钱包地址</span>
													</div>
												)}
											</Item>
											<div className="modal-prompt-others" style={{display:theDigitalWalletAddress.walletAddress ? '' : 'none'}}>
												{theDigitalWalletAddress && <div className="modal-prompt-label-multiple">{theDigitalWalletAddress.walletName}<br />{theDigitalWalletAddress.walletAddress}</div>}
											</div>
										</Spin>
									</React.Fragment>
								) : null}
								{/* 仅作为增加间距盒子 */}
								<div className="line-distance" />
								<Item {...tailFormItemLayout}>
									<div className="btn-wrap">
										<Button
											size="large"
											htmlType="submit"
											block
											className={`${tDBSubmitbtnStatus ? 'active' : 'noactive'}`}
											disabled={!tDBSubmitbtnStatus}
										>
											提交
										</Button>
									</div>
								</Item>
								{isDigitalFunc ? <><div className="line-distance" />
								<div style={{color:'#999'}}><div style={{color:'#666',fontWeight:'bold'}}>乐天使温馨提醒：</div>1. 请在提款前绑定正确的钱包地址。</div></> : null}
							</div>
						) : (
							<div className="ccw-locked-container">
								<img src={'/cn/img/wallet/lock.svg'} alt="lock" />
								<p>抱歉，您无法使用虚拟货币提款，如有任何问题请联系在线客服。</p>
							</div>
						))}
				</Form>
				{/* 成功提交的页面 */}
				{(this.state.isSuccess || tDBisSuccess) && (
					<FinishStep
						collectionInfo={{
							uniqueAmount: withdrawalMoney,
							transactionId: transactionId || this.state.tDBisSuccessId,
							WithdrawKey: this.props.currentWithdrawKey,
							rebateAmount: rebateAmount,
							payoutMode: payoutMode,
							withdrawalTime: this.state.withdrawalTime
						}}
						Time={'60:00'}
						successBy={this.props.currentWithdrawKey}
						goRecord={() => {
							this.goWithdrawHome();
							this.goRecords();
						}}
						goHome={() => {
							this.props.onCancel('ToHome');
						}}
					/>
				)}
				{/* <div
					style={{
						display: this.state.isSuccess && this.props.currentWithdrawKey == 'LB' ? 'block' : 'none'
					}}
				>
					<div className="successPaper">
						<div className="lb-third-step-wrap">
							<Icon type="check-circle" theme="filled" />
							<div className="check-success">
								<div>已成功提交</div>

							</div>
						</div>


						<Steps direction="vertical" size="small">
							<Step status="finish" title={'提交成功'} description={'处理中'} />
							<Step status="wait" description={this.handleTime(maxPayoutDurationInMins)} />
						</Steps>
						<Divider style={{ borderLeft: '330px solid #CCCCCC' }} />
						<div className="showList">
							<div>提款金额</div>
							<div style={{ fontWeight: 'bold' }}>￥{withdrawalMoney}</div>
						</div>
						<Divider style={{ borderLeft: '330px solid #CCCCCC' }} />
						<div className="showList">
							<div>交易单号</div>
							<div>
								{transactionId}
								<CopyToClipboard
									style={{ paddingLeft: '10px' }}
									text={transactionId}
									onCopy={() => message.success('复制成功！')}
								>
									<img src={'/cn/img/wallet/Copy_icon.svg'} />
								</CopyToClipboard>
							</div>
						</div>

						{payoutMode == 'SmallRiver' && (
							<div className="modal-prompt-info" style={{ textAlign: 'left' }}>
								<div className="DONENOTE">
									{rebateAmount != undefined &&
									rebateAmount != 0 && (
										<h3>恭喜您！您在此笔提现交易中将获得额外红利，若您收到该笔交易金额后，可在交易记录页面中查看额外红利并点击“确认到账”领取额外红利。​</h3>
									)}
									{(!rebateAmount || rebateAmount == 0) && <h3>若银行账户已收到该款项，请前往交易记录页面点击”确认到账“。</h3>}
									<br />
									1. 乐天堂<span className="red">不会以任何形式通知</span>会员点击 “确认到账”。<br />
									2. 以电话形式通知点击 “确认到账”皆是诈骗，无需理会。<br />
									​3. 请确保金额到账再点击 “确认到账”，否则金额损失乐天堂<span className="red">概不负责与赔偿</span>。
								</div>
							</div>
						)}
					</div>
					<div className="btn-wrap" style={{ marginTop: '5%' }}>

						<Button
							size="large"
							type="primary"
							htmlType="submit"
							onClick={() => {
								this.goWithdrawHome();
								this.goRecords();
								Pushgtagdata && Pushgtagdata('Transactionrecord_withdrawalsubmission_localbank');
							}}
							block
						>
							查看交易记录
						</Button>
					</div>
					<div className="btn-wrap" style={{ marginTop: '5%' }}>
						<Button size="large" htmlType="submit" onClick={() => this.closeAllModal()} block>
							回到首頁
						</Button>
					</div>
				</div>

				<div
					className="lb-third-step-wrap"
					style={{ display: tDBisSuccess && this.props.currentWithdrawKey == 'CCW' ? 'block' : 'none' }}
				>
					<Icon type="check-circle" theme="filled" />
					<div className="check-success">
						<div>提交成功</div>
						<div className="cuccess">交易编码 :{this.state.tDBisSuccessId}</div>
					</div>
					<p>请注意，交易将以实时汇率进行。</p>
					<div className="btn-wrap">
						<Button size="large" type="primary" htmlType="submit" onClick={this.goRecords} block>
							查看交易记录
						</Button>
					</div>
				</div> */}

				<Modal
					footer={null}
					maskClosable={true}
					onCancel={this.handleCancelModal}
					visible={this.state.lessonModal}
					//className='noDepositTip'
					width={1200}
				>
					<WithdrawLesson onhandleCancel={this.handleCancelModal} />
				</Modal>

				<Modal
					title='代币钱包提款教程'
					footer={null}
					maskClosable={true}
					onCancel={()=>this.setState({digitalCoinLessonModal:false})}
					visible={this.state.digitalCoinLessonModal}
					width={960}
				>
					<DigitalCoinWithdrawLesson />
				</Modal>
                <Modal
                    // copy from pages/cn/USDTintroduce.js
                    title="泰达币提款教程"
                    footer={null}
                    maskClosable={true}
                    onCancel={() => {
                        this.setState({ withdrawLessonModal: false });
                    }}
                    visible={this.state.withdrawLessonModal}
                    width={960}
                    className="UsdtTeachModalStyle udt-withdrawl-modal"
                >
                    <WithdrawLesson
                        onhandleCancel={() => {
                            this.setState({ withdrawLessonModal: false });
                        }}
                    />
                </Modal>


				<PhoneVerify // 手機驗證
					memberInfo={memberInfo && memberInfo}
					visible={phoneVisible}
					closeModal={() => this.setState({ phoneVisible: false })}
					phone={false}
					otpParam={`cry-otp`}
					secondOtpParamIsDigital={isDigitalFunc}
					changeVerify={this.VerifyStatus}
					Description={<div>点击“发送验证码”，您的手机将会收到验证码，请输入您收到的验证码以完成本次验证。</div>}
					callCS={
						<div className="otp-cs-tip">
							{' '}
							如果您想更新手机号码，请联系我们的
							<span className="otp-cs" onClick={() => global.PopUpLiveChat()}>
								在线客服
							</span>
						</div>
					}
					modalTitle={isDigitalFunc ? '添加代币钱包地址' : `添加 ${ctcMethod} 钱包地址`}
					times={5}
					attemptRemaining={checkAbleSmsOTP.attempts}
					setAttemptRemaining={this.setAttemptRemaining}
					judgeOTPVerification={this.judgeOTPVerification}
					getVerificationCode={this.getVerificationCode}
				/>

				<ExceedVerify // otp 超過次數彈窗
					exceedVisible={exceedVisible}
					times={5}
					headTitle={isDigitalFunc ? '添加代币钱包地址' : `添加 ${ctcMethod} 钱包地址`}
					onCancel={() => this.setState({ exceedVisible: false })}
					Description={
						// <div className="otp-cs-tip">
						//     请联系我们的
						//     <span
						//         className="otp-cs"
						//         onClick={() => {
						//             global.PopUpLiveChat();
						//             Pushgtagdata("CS_exceeded_TTD_OTP");
						//         }}
						//     >
						//         在线客服
						//     </span>
						//     进行验证，或是在24小时后可以再次尝试。
						// </div>
						<div className="otp-cs-tip-exceed">请 24 小时之后再试或联系我们的在线客服进行验证。</div>
					}
				/>

				<AddWalletAddress // 添加 USDT 钱包地址
					visibleExchangeRateWallet={visibleExchangeRateWallet}
					leaveAddWallet={() => this.setState({ leaveAddWalletVisible: true })}
					exchangeRateWalletTest={this.exchangeRateWalletTest}
					handleOk={this.handleOk}
					addTDBBtnStatue={addTDBBtnStatue}
					tDBName={tDBName}
					tDBAddress={tDBAddress}
					tDBNameError={tDBNameError}
					tDBAddressError2={tDBAddressError2}
					tDBAddressError={tDBAddressError}
					ctcMethod={ctcMethod}
				/>

				{this.DigitalCoinTrait.renderAddModal()}

				<Modal
					centered={true}
					title="温馨提醒"
					footer={null}
					maskClosable={false}
					onCancel={this.leaveWalletButtonHandle.bind(this, true)}
					visible={this.state.leaveAddWalletVisible}
					width={400}
					className="leaveAddWalletModal"
				>
					<div className="content" style={{textAlign:'center'}}>您将需要再次验证电话号码以访问此页面，你确定要离开吗？</div>
					<div className="buttonWrap">
						<Button className="blueTextAndBorder" onClick={this.leaveWalletButtonHandle.bind(this, false)}>离开</Button>
						<Button onClick={this.leaveWalletButtonHandle.bind(this, true)}>继续添加钱包</Button>
					</div>
				</Modal>

				<Modal
					centered={true}
					title="注意"
					footer={null}
					maskClosable={false}
					closable={true}
					visible={isShowLBWithdrawalModal}
					width={400}
					className="checkLBWithdrawalModal"
					onCancel={() => {
						this.setState({ isShowLBWithdrawalModal: false });
					}}
				>
					<div className="msg1">
						该账户已到达提款限额，您是否要继续？点击此处
						<span onClick={() => this.setState({ bankWithdrawalDetail: true })}>查看提款记录。</span>
					</div>
					<div className="msg2">
						了解更多关于
						<span onClick={() => this.setState({ bankAccountModal: true })}>提现限额设置。</span>
					</div>
					<div className="btn">
						<Button
							onClick={() => {
								this.lBWithdrawalBtn('carryOn');
								switch (this.props.currentWithdrawKey) {
									case 'LB':
										Pushgtagdata('Withdrawal', 'Submit', 'Submit_LocalBank_Withdrawal');
										break;
									default:
										Pushgtagdata('Submit_withdrawal_wallet');
										break;
								}
							}}
						>
							继续
						</Button>
						<Button
							onClick={() => {
								this.lBWithdrawalBtn('goAway');
							}}
						>
							更换银行账户
						</Button>
					</div>
				</Modal>
				<AddBankCard
					useAt={'WITHDRAWAL'}
					visible={this.state.isAddBankAccountModalVisible}
					closeModal={() => {
						this.openBankCardModalCancelFunc(this.state.whenAddBankAccountModalVisibleTrueAt);
						this.setState({ isAddBankAccountModalVisible: false });
					}}
					getMemberBanksList={()=>this.componentDidMount4Reuse(true)} // in order to re-check AddBank&KYC to show AddBank&KYC modal if have/need
				/>
				{this.state.bankWithdrawalDetail && (
					<BankWithdrawalDetails
						visible={this.state.bankWithdrawalDetail}
						closeModal={(v) => {
							this.setState({ bankWithdrawalDetail: v });
						}}
						bankAccountNumber={this.state.alreadyBindBanks[this.state.defaultBankCardId].accountNumber}
						setIsLoading={(v) => {
							this.setLoading(v);
						}}
					/>
				)}
				{this.state.bankAccountModal && (
					<BankAccountModals
						visible={this.state.bankAccountModal}
						closeModal={(v) => {
							this.setState({ bankAccountModal: v });
							this.setState({ isShowLBWithdrawalModal: v });
						}}
						getMemberWithdrawalThresho={this.getLBWithdrawalSetUp}
					/>
				)}
				{/* <CardId
					step={this.state.step}
					userInfo={this.state.userInfo}
					submitOTPAttempts={this.state.submitOTPAttempts}
					realyNameVisible={this.state.isOpenRealyName}
					nextStep={(v) => {
						this.setState({ step: v });
					}}
					verifySuccess={(v) => {
						this.setState({ isOpenRealyName: v });
					}}
					setSubmitOTPAttempts={(v) => {
						this.setState({ submitOTPAttempts: v });
					}}
					onChangeUserInfo={(v) => this.setState({ userInfo: v })}
					closeAllModal={this.closeAllModal}
					exceedTryNumber={this.exceedTryNumber}
					setLoading={this.setLoading}
					getPayMethod={this.againGetWithdrawalMethods}
					banksVerificationManual={banksVerificationManual}
					setBanksVerificationManual={(v) => {
						this.setState({ banksVerificationManual: v });
					}}
				/> */}
				{/* 提款验证 */}
				{ToAccountVerification &&
				memberInfo.withdrawalVerifyStep && (
					<AccountVerification
						otpVisible={ToAccountVerification}
						otpModal={(v) => {
							this.props.onCancel();
						}}
						otpParam={`withdrawal-otp`}
						memberInfo={memberInfo}
						getMemberData={() => {
							this.getDepositFrontData(4);
						}}
						readStep={memberInfo.withdrawalVerifyStep}
						coloseVisible={() => {
							this.setState({
								ToAccountVerification: false
							});
							this.componentDidMount4Reuse(true); // in order to re-check AddBank&KYC to show AddBank&KYC modal if have/need
						}}
						key={memberInfo.withdrawalVerifyStep}
					/>
				)}
			</React.Fragment>
		);
	}
}
export default Form.create({ name: 'Withdrawal' })(Withdrawal);
